/**
 * COMPLETE MASTER SCHEDULE - GENERATED BALANCED SCHEDULE
 *
 * 24 teams, 160 games each, 1920 total games
 * Days 2-183 (April 2 - September 30)
 *
 * SLOT MAPPING:
 * American East (0-5):   0-NY Pirates, 1-Phoenix, 2-Montreal, 3-Mexico City, 4-Forest Park, 5-Katutura
 * American West (6-11):  6-Atlanta, 7-Louisville, 8-Peoria, 9-Covington, 10-Queens Park, 11-Palm Beach
 * National East (12-17): 12-Bayside, 13-Tewksbury, 14-Old Sarum, 15-Jacksonville, 16-Arkansas, 17-West Side
 * National West (18-23): 18-Saskatchewan, 19-Gibsonville, 20-Caledonia, 21-High Country, 22-Jefferson City, 23-Deer Creek
 */

export interface GameEntry {
  day: number;
  homeSlot: number;
  awaySlot: number;
}

export const COMPLETE_MASTER_SCHEDULE: GameEntry[] = [
  { day: 2, homeSlot: 0, awaySlot: 1 },
  { day: 2, homeSlot: 2, awaySlot: 4 },
  { day: 2, homeSlot: 3, awaySlot: 18 },
  { day: 2, homeSlot: 6, awaySlot: 11 },
  { day: 2, homeSlot: 7, awaySlot: 10 },
  { day: 2, homeSlot: 8, awaySlot: 23 },
  { day: 2, homeSlot: 9, awaySlot: 5 },
  { day: 2, homeSlot: 12, awaySlot: 19 },
  { day: 2, homeSlot: 14, awaySlot: 15 },
  { day: 2, homeSlot: 17, awaySlot: 22 },
  { day: 2, homeSlot: 20, awaySlot: 13 },
  { day: 2, homeSlot: 21, awaySlot: 16 },
  { day: 3, homeSlot: 0, awaySlot: 4 },
  { day: 3, homeSlot: 1, awaySlot: 5 },
  { day: 3, homeSlot: 2, awaySlot: 3 },
  { day: 3, homeSlot: 6, awaySlot: 9 },
  { day: 3, homeSlot: 7, awaySlot: 8 },
  { day: 3, homeSlot: 10, awaySlot: 11 },
  { day: 3, homeSlot: 12, awaySlot: 23 },
  { day: 3, homeSlot: 13, awaySlot: 16 },
  { day: 3, homeSlot: 14, awaySlot: 15 },
  { day: 3, homeSlot: 17, awaySlot: 22 },
  { day: 3, homeSlot: 18, awaySlot: 19 },
  { day: 3, homeSlot: 20, awaySlot: 21 },
  { day: 4, homeSlot: 0, awaySlot: 1 },
  { day: 4, homeSlot: 2, awaySlot: 5 },
  { day: 4, homeSlot: 3, awaySlot: 4 },
  { day: 4, homeSlot: 7, awaySlot: 12 },
  { day: 4, homeSlot: 8, awaySlot: 10 },
  { day: 4, homeSlot: 9, awaySlot: 11 },
  { day: 4, homeSlot: 14, awaySlot: 17 },
  { day: 4, homeSlot: 16, awaySlot: 6 },
  { day: 4, homeSlot: 18, awaySlot: 15 },
  { day: 4, homeSlot: 19, awaySlot: 21 },
  { day: 4, homeSlot: 22, awaySlot: 20 },
  { day: 4, homeSlot: 23, awaySlot: 13 },
  { day: 5, homeSlot: 0, awaySlot: 5 },
  { day: 5, homeSlot: 1, awaySlot: 22 },
  { day: 5, homeSlot: 2, awaySlot: 4 },
  { day: 5, homeSlot: 6, awaySlot: 11 },
  { day: 5, homeSlot: 7, awaySlot: 9 },
  { day: 5, homeSlot: 8, awaySlot: 10 },
  { day: 5, homeSlot: 12, awaySlot: 16 },
  { day: 5, homeSlot: 13, awaySlot: 21 },
  { day: 5, homeSlot: 15, awaySlot: 20 },
  { day: 5, homeSlot: 17, awaySlot: 14 },
  { day: 5, homeSlot: 18, awaySlot: 19 },
  { day: 5, homeSlot: 23, awaySlot: 3 },
  { day: 6, homeSlot: 0, awaySlot: 1 },
  { day: 6, homeSlot: 2, awaySlot: 20 },
  { day: 6, homeSlot: 3, awaySlot: 5 },
  { day: 6, homeSlot: 6, awaySlot: 11 },
  { day: 6, homeSlot: 7, awaySlot: 10 },
  { day: 6, homeSlot: 8, awaySlot: 9 },
  { day: 6, homeSlot: 13, awaySlot: 14 },
  { day: 6, homeSlot: 15, awaySlot: 16 },
  { day: 6, homeSlot: 18, awaySlot: 17 },
  { day: 6, homeSlot: 19, awaySlot: 4 },
  { day: 6, homeSlot: 21, awaySlot: 12 },
  { day: 6, homeSlot: 22, awaySlot: 23 },
  { day: 7, homeSlot: 0, awaySlot: 4 },
  { day: 7, homeSlot: 1, awaySlot: 2 },
  { day: 7, homeSlot: 3, awaySlot: 5 },
  { day: 7, homeSlot: 6, awaySlot: 8 },
  { day: 7, homeSlot: 7, awaySlot: 11 },
  { day: 7, homeSlot: 9, awaySlot: 20 },
  { day: 7, homeSlot: 10, awaySlot: 18 },
  { day: 7, homeSlot: 12, awaySlot: 16 },
  { day: 7, homeSlot: 13, awaySlot: 17 },
  { day: 7, homeSlot: 19, awaySlot: 14 },
  { day: 7, homeSlot: 21, awaySlot: 22 },
  { day: 7, homeSlot: 23, awaySlot: 15 },
  { day: 9, homeSlot: 0, awaySlot: 5 },
  { day: 9, homeSlot: 2, awaySlot: 4 },
  { day: 9, homeSlot: 3, awaySlot: 10 },
  { day: 9, homeSlot: 6, awaySlot: 7 },
  { day: 9, homeSlot: 12, awaySlot: 16 },
  { day: 9, homeSlot: 14, awaySlot: 1 },
  { day: 9, homeSlot: 17, awaySlot: 15 },
  { day: 9, homeSlot: 18, awaySlot: 20 },
  { day: 9, homeSlot: 19, awaySlot: 13 },
  { day: 9, homeSlot: 21, awaySlot: 8 },
  { day: 9, homeSlot: 22, awaySlot: 11 },
  { day: 9, homeSlot: 23, awaySlot: 9 },
  { day: 10, homeSlot: 0, awaySlot: 16 },
  { day: 10, homeSlot: 2, awaySlot: 7 },
  { day: 10, homeSlot: 4, awaySlot: 5 },
  { day: 10, homeSlot: 6, awaySlot: 3 },
  { day: 10, homeSlot: 8, awaySlot: 11 },
  { day: 10, homeSlot: 10, awaySlot: 9 },
  { day: 10, homeSlot: 12, awaySlot: 18 },
  { day: 10, homeSlot: 13, awaySlot: 1 },
  { day: 10, homeSlot: 14, awaySlot: 22 },
  { day: 10, homeSlot: 17, awaySlot: 21 },
  { day: 10, homeSlot: 20, awaySlot: 15 },
  { day: 10, homeSlot: 23, awaySlot: 19 },
  { day: 11, homeSlot: 1, awaySlot: 4 },
  { day: 11, homeSlot: 3, awaySlot: 9 },
  { day: 11, homeSlot: 5, awaySlot: 8 },
  { day: 11, homeSlot: 6, awaySlot: 7 },
  { day: 11, homeSlot: 10, awaySlot: 11 },
  { day: 11, homeSlot: 12, awaySlot: 0 },
  { day: 11, homeSlot: 13, awaySlot: 16 },
  { day: 11, homeSlot: 14, awaySlot: 20 },
  { day: 11, homeSlot: 15, awaySlot: 19 },
  { day: 11, homeSlot: 17, awaySlot: 2 },
  { day: 11, homeSlot: 18, awaySlot: 22 },
  { day: 11, homeSlot: 21, awaySlot: 23 },
  { day: 12, homeSlot: 0, awaySlot: 1 },
  { day: 12, homeSlot: 3, awaySlot: 2 },
  { day: 12, homeSlot: 4, awaySlot: 5 },
  { day: 12, homeSlot: 6, awaySlot: 9 },
  { day: 12, homeSlot: 7, awaySlot: 8 },
  { day: 12, homeSlot: 11, awaySlot: 12 },
  { day: 12, homeSlot: 13, awaySlot: 14 },
  { day: 12, homeSlot: 15, awaySlot: 23 },
  { day: 12, homeSlot: 17, awaySlot: 18 },
  { day: 12, homeSlot: 20, awaySlot: 16 },
  { day: 12, homeSlot: 21, awaySlot: 19 },
  { day: 12, homeSlot: 22, awaySlot: 10 },
  { day: 13, homeSlot: 0, awaySlot: 7 },
  { day: 13, homeSlot: 1, awaySlot: 3 },
  { day: 13, homeSlot: 4, awaySlot: 5 },
  { day: 13, homeSlot: 6, awaySlot: 9 },
  { day: 13, homeSlot: 8, awaySlot: 2 },
  { day: 13, homeSlot: 10, awaySlot: 11 },
  { day: 13, homeSlot: 12, awaySlot: 19 },
  { day: 13, homeSlot: 13, awaySlot: 16 },
  { day: 13, homeSlot: 14, awaySlot: 15 },
  { day: 13, homeSlot: 18, awaySlot: 20 },
  { day: 13, homeSlot: 21, awaySlot: 22 },
  { day: 13, homeSlot: 23, awaySlot: 17 },
  { day: 14, homeSlot: 1, awaySlot: 4 },
  { day: 14, homeSlot: 2, awaySlot: 3 },
  { day: 14, homeSlot: 7, awaySlot: 5 },
  { day: 14, homeSlot: 8, awaySlot: 9 },
  { day: 14, homeSlot: 10, awaySlot: 11 },
  { day: 14, homeSlot: 12, awaySlot: 17 },
  { day: 14, homeSlot: 13, awaySlot: 15 },
  { day: 14, homeSlot: 16, awaySlot: 0 },
  { day: 14, homeSlot: 18, awaySlot: 21 },
  { day: 14, homeSlot: 19, awaySlot: 6 },
  { day: 14, homeSlot: 20, awaySlot: 14 },
  { day: 14, homeSlot: 23, awaySlot: 22 },
  { day: 15, homeSlot: 1, awaySlot: 13 },
  { day: 15, homeSlot: 3, awaySlot: 5 },
  { day: 15, homeSlot: 4, awaySlot: 0 },
  { day: 15, homeSlot: 6, awaySlot: 9 },
  { day: 15, homeSlot: 7, awaySlot: 11 },
  { day: 15, homeSlot: 10, awaySlot: 8 },
  { day: 15, homeSlot: 12, awaySlot: 23 },
  { day: 15, homeSlot: 15, awaySlot: 17 },
  { day: 15, homeSlot: 18, awaySlot: 14 },
  { day: 15, homeSlot: 20, awaySlot: 16 },
  { day: 15, homeSlot: 21, awaySlot: 2 },
  { day: 15, homeSlot: 22, awaySlot: 19 },
  { day: 16, homeSlot: 2, awaySlot: 0 },
  { day: 16, homeSlot: 3, awaySlot: 5 },
  { day: 16, homeSlot: 6, awaySlot: 4 },
  { day: 16, homeSlot: 7, awaySlot: 1 },
  { day: 16, homeSlot: 8, awaySlot: 18 },
  { day: 16, homeSlot: 9, awaySlot: 10 },
  { day: 16, homeSlot: 11, awaySlot: 23 },
  { day: 16, homeSlot: 12, awaySlot: 16 },
  { day: 16, homeSlot: 13, awaySlot: 15 },
  { day: 16, homeSlot: 20, awaySlot: 19 },
  { day: 16, homeSlot: 21, awaySlot: 14 },
  { day: 16, homeSlot: 22, awaySlot: 17 },
  { day: 17, homeSlot: 3, awaySlot: 0 },
  { day: 17, homeSlot: 5, awaySlot: 1 },
  { day: 17, homeSlot: 6, awaySlot: 8 },
  { day: 17, homeSlot: 7, awaySlot: 11 },
  { day: 17, homeSlot: 9, awaySlot: 10 },
  { day: 17, homeSlot: 13, awaySlot: 23 },
  { day: 17, homeSlot: 14, awaySlot: 2 },
  { day: 17, homeSlot: 15, awaySlot: 17 },
  { day: 17, homeSlot: 16, awaySlot: 12 },
  { day: 17, homeSlot: 18, awaySlot: 19 },
  { day: 17, homeSlot: 20, awaySlot: 4 },
  { day: 17, homeSlot: 21, awaySlot: 22 },
  { day: 18, homeSlot: 2, awaySlot: 5 },
  { day: 18, homeSlot: 3, awaySlot: 23 },
  { day: 18, homeSlot: 4, awaySlot: 11 },
  { day: 18, homeSlot: 6, awaySlot: 9 },
  { day: 18, homeSlot: 7, awaySlot: 13 },
  { day: 18, homeSlot: 8, awaySlot: 10 },
  { day: 18, homeSlot: 12, awaySlot: 1 },
  { day: 18, homeSlot: 14, awaySlot: 15 },
  { day: 18, homeSlot: 16, awaySlot: 17 },
  { day: 18, homeSlot: 18, awaySlot: 19 },
  { day: 18, homeSlot: 20, awaySlot: 22 },
  { day: 18, homeSlot: 21, awaySlot: 0 },
  { day: 20, homeSlot: 0, awaySlot: 1 },
  { day: 20, homeSlot: 2, awaySlot: 8 },
  { day: 20, homeSlot: 3, awaySlot: 5 },
  { day: 20, homeSlot: 4, awaySlot: 17 },
  { day: 20, homeSlot: 6, awaySlot: 10 },
  { day: 20, homeSlot: 7, awaySlot: 11 },
  { day: 20, homeSlot: 9, awaySlot: 16 },
  { day: 20, homeSlot: 15, awaySlot: 12 },
  { day: 20, homeSlot: 18, awaySlot: 14 },
  { day: 20, homeSlot: 19, awaySlot: 20 },
  { day: 20, homeSlot: 21, awaySlot: 23 },
  { day: 20, homeSlot: 22, awaySlot: 13 },
  { day: 21, homeSlot: 0, awaySlot: 11 },
  { day: 21, homeSlot: 1, awaySlot: 5 },
  { day: 21, homeSlot: 2, awaySlot: 6 },
  { day: 21, homeSlot: 7, awaySlot: 10 },
  { day: 21, homeSlot: 9, awaySlot: 8 },
  { day: 21, homeSlot: 12, awaySlot: 14 },
  { day: 21, homeSlot: 13, awaySlot: 17 },
  { day: 21, homeSlot: 15, awaySlot: 18 },
  { day: 21, homeSlot: 19, awaySlot: 16 },
  { day: 21, homeSlot: 20, awaySlot: 3 },
  { day: 21, homeSlot: 21, awaySlot: 23 },
  { day: 21, homeSlot: 22, awaySlot: 4 },
  { day: 22, homeSlot: 0, awaySlot: 5 },
  { day: 22, homeSlot: 1, awaySlot: 10 },
  { day: 22, homeSlot: 2, awaySlot: 18 },
  { day: 22, homeSlot: 6, awaySlot: 4 },
  { day: 22, homeSlot: 7, awaySlot: 8 },
  { day: 22, homeSlot: 9, awaySlot: 19 },
  { day: 22, homeSlot: 11, awaySlot: 3 },
  { day: 22, homeSlot: 12, awaySlot: 17 },
  { day: 22, homeSlot: 13, awaySlot: 14 },
  { day: 22, homeSlot: 15, awaySlot: 16 },
  { day: 22, homeSlot: 20, awaySlot: 23 },
  { day: 22, homeSlot: 21, awaySlot: 22 },
  { day: 23, homeSlot: 0, awaySlot: 8 },
  { day: 23, homeSlot: 1, awaySlot: 2 },
  { day: 23, homeSlot: 4, awaySlot: 5 },
  { day: 23, homeSlot: 6, awaySlot: 17 },
  { day: 23, homeSlot: 7, awaySlot: 9 },
  { day: 23, homeSlot: 10, awaySlot: 11 },
  { day: 23, homeSlot: 12, awaySlot: 15 },
  { day: 23, homeSlot: 13, awaySlot: 22 },
  { day: 23, homeSlot: 14, awaySlot: 16 },
  { day: 23, homeSlot: 18, awaySlot: 20 },
  { day: 23, homeSlot: 19, awaySlot: 21 },
  { day: 23, homeSlot: 23, awaySlot: 3 },
  { day: 24, homeSlot: 1, awaySlot: 3 },
  { day: 24, homeSlot: 4, awaySlot: 5 },
  { day: 24, homeSlot: 6, awaySlot: 10 },
  { day: 24, homeSlot: 7, awaySlot: 8 },
  { day: 24, homeSlot: 9, awaySlot: 2 },
  { day: 24, homeSlot: 12, awaySlot: 11 },
  { day: 24, homeSlot: 13, awaySlot: 15 },
  { day: 24, homeSlot: 16, awaySlot: 14 },
  { day: 24, homeSlot: 17, awaySlot: 23 },
  { day: 24, homeSlot: 18, awaySlot: 20 },
  { day: 24, homeSlot: 21, awaySlot: 19 },
  { day: 24, homeSlot: 22, awaySlot: 0 },
  { day: 25, homeSlot: 1, awaySlot: 3 },
  { day: 25, homeSlot: 2, awaySlot: 16 },
  { day: 25, homeSlot: 5, awaySlot: 14 },
  { day: 25, homeSlot: 8, awaySlot: 0 },
  { day: 25, homeSlot: 10, awaySlot: 4 },
  { day: 25, homeSlot: 11, awaySlot: 9 },
  { day: 25, homeSlot: 17, awaySlot: 13 },
  { day: 25, homeSlot: 18, awaySlot: 7 },
  { day: 25, homeSlot: 20, awaySlot: 19 },
  { day: 25, homeSlot: 21, awaySlot: 15 },
  { day: 25, homeSlot: 22, awaySlot: 6 },
  { day: 25, homeSlot: 23, awaySlot: 12 },
  { day: 26, homeSlot: 1, awaySlot: 2 },
  { day: 26, homeSlot: 3, awaySlot: 6 },
  { day: 26, homeSlot: 4, awaySlot: 15 },
  { day: 26, homeSlot: 7, awaySlot: 11 },
  { day: 26, homeSlot: 8, awaySlot: 9 },
  { day: 26, homeSlot: 10, awaySlot: 5 },
  { day: 26, homeSlot: 13, awaySlot: 12 },
  { day: 26, homeSlot: 16, awaySlot: 17 },
  { day: 26, homeSlot: 18, awaySlot: 19 },
  { day: 26, homeSlot: 20, awaySlot: 21 },
  { day: 26, homeSlot: 22, awaySlot: 0 },
  { day: 26, homeSlot: 23, awaySlot: 14 },
  { day: 27, homeSlot: 0, awaySlot: 2 },
  { day: 27, homeSlot: 3, awaySlot: 20 },
  { day: 27, homeSlot: 5, awaySlot: 14 },
  { day: 27, homeSlot: 6, awaySlot: 11 },
  { day: 27, homeSlot: 7, awaySlot: 12 },
  { day: 27, homeSlot: 8, awaySlot: 1 },
  { day: 27, homeSlot: 9, awaySlot: 19 },
  { day: 27, homeSlot: 10, awaySlot: 4 },
  { day: 27, homeSlot: 17, awaySlot: 23 },
  { day: 27, homeSlot: 18, awaySlot: 15 },
  { day: 27, homeSlot: 21, awaySlot: 13 },
  { day: 27, homeSlot: 22, awaySlot: 16 },
  { day: 28, homeSlot: 0, awaySlot: 10 },
  { day: 28, homeSlot: 1, awaySlot: 5 },
  { day: 28, homeSlot: 3, awaySlot: 4 },
  { day: 28, homeSlot: 7, awaySlot: 8 },
  { day: 28, homeSlot: 9, awaySlot: 13 },
  { day: 28, homeSlot: 11, awaySlot: 6 },
  { day: 28, homeSlot: 15, awaySlot: 2 },
  { day: 28, homeSlot: 16, awaySlot: 21 },
  { day: 28, homeSlot: 18, awaySlot: 17 },
  { day: 28, homeSlot: 19, awaySlot: 23 },
  { day: 28, homeSlot: 20, awaySlot: 14 },
  { day: 28, homeSlot: 22, awaySlot: 12 },
  { day: 29, homeSlot: 1, awaySlot: 7 },
  { day: 29, homeSlot: 2, awaySlot: 3 },
  { day: 29, homeSlot: 4, awaySlot: 0 },
  { day: 29, homeSlot: 6, awaySlot: 9 },
  { day: 29, homeSlot: 10, awaySlot: 8 },
  { day: 29, homeSlot: 11, awaySlot: 5 },
  { day: 29, homeSlot: 14, awaySlot: 17 },
  { day: 29, homeSlot: 16, awaySlot: 12 },
  { day: 29, homeSlot: 18, awaySlot: 23 },
  { day: 29, homeSlot: 19, awaySlot: 22 },
  { day: 29, homeSlot: 20, awaySlot: 15 },
  { day: 29, homeSlot: 21, awaySlot: 13 },
  { day: 31, homeSlot: 0, awaySlot: 4 },
  { day: 31, homeSlot: 1, awaySlot: 8 },
  { day: 31, homeSlot: 5, awaySlot: 20 },
  { day: 31, homeSlot: 6, awaySlot: 10 },
  { day: 31, homeSlot: 9, awaySlot: 7 },
  { day: 31, homeSlot: 11, awaySlot: 2 },
  { day: 31, homeSlot: 12, awaySlot: 17 },
  { day: 31, homeSlot: 13, awaySlot: 14 },
  { day: 31, homeSlot: 18, awaySlot: 23 },
  { day: 31, homeSlot: 19, awaySlot: 15 },
  { day: 31, homeSlot: 21, awaySlot: 3 },
  { day: 31, homeSlot: 22, awaySlot: 16 },
  { day: 32, homeSlot: 0, awaySlot: 5 },
  { day: 32, homeSlot: 2, awaySlot: 9 },
  { day: 32, homeSlot: 3, awaySlot: 4 },
  { day: 32, homeSlot: 6, awaySlot: 13 },
  { day: 32, homeSlot: 8, awaySlot: 11 },
  { day: 32, homeSlot: 10, awaySlot: 14 },
  { day: 32, homeSlot: 12, awaySlot: 7 },
  { day: 32, homeSlot: 17, awaySlot: 15 },
  { day: 32, homeSlot: 18, awaySlot: 16 },
  { day: 32, homeSlot: 19, awaySlot: 20 },
  { day: 32, homeSlot: 21, awaySlot: 23 },
  { day: 32, homeSlot: 22, awaySlot: 1 },
  { day: 33, homeSlot: 1, awaySlot: 17 },
  { day: 33, homeSlot: 3, awaySlot: 22 },
  { day: 33, homeSlot: 4, awaySlot: 9 },
  { day: 33, homeSlot: 6, awaySlot: 5 },
  { day: 33, homeSlot: 7, awaySlot: 2 },
  { day: 33, homeSlot: 10, awaySlot: 12 },
  { day: 33, homeSlot: 14, awaySlot: 11 },
  { day: 33, homeSlot: 15, awaySlot: 21 },
  { day: 33, homeSlot: 16, awaySlot: 20 },
  { day: 33, homeSlot: 18, awaySlot: 13 },
  { day: 33, homeSlot: 19, awaySlot: 0 },
  { day: 33, homeSlot: 23, awaySlot: 8 },
  { day: 34, homeSlot: 0, awaySlot: 3 },
  { day: 34, homeSlot: 4, awaySlot: 1 },
  { day: 34, homeSlot: 5, awaySlot: 18 },
  { day: 34, homeSlot: 6, awaySlot: 9 },
  { day: 34, homeSlot: 7, awaySlot: 2 },
  { day: 34, homeSlot: 8, awaySlot: 10 },
  { day: 34, homeSlot: 11, awaySlot: 21 },
  { day: 34, homeSlot: 14, awaySlot: 17 },
  { day: 34, homeSlot: 15, awaySlot: 13 },
  { day: 34, homeSlot: 19, awaySlot: 16 },
  { day: 34, homeSlot: 22, awaySlot: 12 },
  { day: 34, homeSlot: 23, awaySlot: 20 },
  { day: 35, homeSlot: 0, awaySlot: 8 },
  { day: 35, homeSlot: 2, awaySlot: 22 },
  { day: 35, homeSlot: 3, awaySlot: 11 },
  { day: 35, homeSlot: 4, awaySlot: 1 },
  { day: 35, homeSlot: 5, awaySlot: 10 },
  { day: 35, homeSlot: 6, awaySlot: 7 },
  { day: 35, homeSlot: 9, awaySlot: 15 },
  { day: 35, homeSlot: 12, awaySlot: 20 },
  { day: 35, homeSlot: 13, awaySlot: 19 },
  { day: 35, homeSlot: 16, awaySlot: 17 },
  { day: 35, homeSlot: 18, awaySlot: 21 },
  { day: 35, homeSlot: 23, awaySlot: 14 },
  { day: 36, homeSlot: 3, awaySlot: 7 },
  { day: 36, homeSlot: 4, awaySlot: 16 },
  { day: 36, homeSlot: 5, awaySlot: 23 },
  { day: 36, homeSlot: 6, awaySlot: 10 },
  { day: 36, homeSlot: 8, awaySlot: 15 },
  { day: 36, homeSlot: 9, awaySlot: 0 },
  { day: 36, homeSlot: 11, awaySlot: 20 },
  { day: 36, homeSlot: 14, awaySlot: 1 },
  { day: 36, homeSlot: 17, awaySlot: 13 },
  { day: 36, homeSlot: 18, awaySlot: 22 },
  { day: 36, homeSlot: 19, awaySlot: 12 },
  { day: 36, homeSlot: 21, awaySlot: 2 },
  { day: 37, homeSlot: 1, awaySlot: 9 },
  { day: 37, homeSlot: 2, awaySlot: 5 },
  { day: 37, homeSlot: 4, awaySlot: 16 },
  { day: 37, homeSlot: 6, awaySlot: 17 },
  { day: 37, homeSlot: 7, awaySlot: 11 },
  { day: 37, homeSlot: 8, awaySlot: 0 },
  { day: 37, homeSlot: 12, awaySlot: 15 },
  { day: 37, homeSlot: 13, awaySlot: 3 },
  { day: 37, homeSlot: 18, awaySlot: 20 },
  { day: 37, homeSlot: 19, awaySlot: 14 },
  { day: 37, homeSlot: 22, awaySlot: 21 },
  { day: 37, homeSlot: 23, awaySlot: 10 },
  { day: 38, homeSlot: 1, awaySlot: 10 },
  { day: 38, homeSlot: 6, awaySlot: 2 },
  { day: 38, homeSlot: 7, awaySlot: 4 },
  { day: 38, homeSlot: 9, awaySlot: 5 },
  { day: 38, homeSlot: 11, awaySlot: 8 },
  { day: 38, homeSlot: 13, awaySlot: 16 },
  { day: 38, homeSlot: 17, awaySlot: 21 },
  { day: 38, homeSlot: 18, awaySlot: 12 },
  { day: 38, homeSlot: 19, awaySlot: 0 },
  { day: 38, homeSlot: 20, awaySlot: 14 },
  { day: 38, homeSlot: 22, awaySlot: 3 },
  { day: 38, homeSlot: 23, awaySlot: 15 },
  { day: 39, homeSlot: 1, awaySlot: 8 },
  { day: 39, homeSlot: 2, awaySlot: 10 },
  { day: 39, homeSlot: 3, awaySlot: 4 },
  { day: 39, homeSlot: 5, awaySlot: 0 },
  { day: 39, homeSlot: 7, awaySlot: 9 },
  { day: 39, homeSlot: 11, awaySlot: 6 },
  { day: 39, homeSlot: 13, awaySlot: 14 },
  { day: 39, homeSlot: 16, awaySlot: 12 },
  { day: 39, homeSlot: 17, awaySlot: 18 },
  { day: 39, homeSlot: 19, awaySlot: 20 },
  { day: 39, homeSlot: 21, awaySlot: 23 },
  { day: 39, homeSlot: 22, awaySlot: 15 },
  { day: 40, homeSlot: 0, awaySlot: 5 },
  { day: 40, homeSlot: 3, awaySlot: 12 },
  { day: 40, homeSlot: 4, awaySlot: 8 },
  { day: 40, homeSlot: 7, awaySlot: 6 },
  { day: 40, homeSlot: 9, awaySlot: 2 },
  { day: 40, homeSlot: 10, awaySlot: 1 },
  { day: 40, homeSlot: 11, awaySlot: 17 },
  { day: 40, homeSlot: 14, awaySlot: 19 },
  { day: 40, homeSlot: 18, awaySlot: 15 },
  { day: 40, homeSlot: 20, awaySlot: 13 },
  { day: 40, homeSlot: 22, awaySlot: 21 },
  { day: 40, homeSlot: 23, awaySlot: 16 },
  { day: 41, homeSlot: 0, awaySlot: 2 },
  { day: 41, homeSlot: 3, awaySlot: 11 },
  { day: 41, homeSlot: 5, awaySlot: 1 },
  { day: 41, homeSlot: 6, awaySlot: 12 },
  { day: 41, homeSlot: 7, awaySlot: 4 },
  { day: 41, homeSlot: 9, awaySlot: 10 },
  { day: 41, homeSlot: 15, awaySlot: 13 },
  { day: 41, homeSlot: 16, awaySlot: 14 },
  { day: 41, homeSlot: 17, awaySlot: 21 },
  { day: 41, homeSlot: 18, awaySlot: 23 },
  { day: 41, homeSlot: 19, awaySlot: 22 },
  { day: 41, homeSlot: 20, awaySlot: 8 },
  { day: 43, homeSlot: 0, awaySlot: 5 },
  { day: 43, homeSlot: 2, awaySlot: 1 },
  { day: 43, homeSlot: 6, awaySlot: 8 },
  { day: 43, homeSlot: 9, awaySlot: 3 },
  { day: 43, homeSlot: 10, awaySlot: 19 },
  { day: 43, homeSlot: 11, awaySlot: 22 },
  { day: 43, homeSlot: 12, awaySlot: 17 },
  { day: 43, homeSlot: 13, awaySlot: 20 },
  { day: 43, homeSlot: 15, awaySlot: 14 },
  { day: 43, homeSlot: 18, awaySlot: 4 },
  { day: 43, homeSlot: 21, awaySlot: 16 },
  { day: 43, homeSlot: 23, awaySlot: 7 },
  { day: 44, homeSlot: 0, awaySlot: 21 },
  { day: 44, homeSlot: 1, awaySlot: 4 },
  { day: 44, homeSlot: 3, awaySlot: 2 },
  { day: 44, homeSlot: 5, awaySlot: 9 },
  { day: 44, homeSlot: 6, awaySlot: 11 },
  { day: 44, homeSlot: 8, awaySlot: 19 },
  { day: 44, homeSlot: 10, awaySlot: 7 },
  { day: 44, homeSlot: 12, awaySlot: 14 },
  { day: 44, homeSlot: 13, awaySlot: 23 },
  { day: 44, homeSlot: 15, awaySlot: 18 },
  { day: 44, homeSlot: 20, awaySlot: 16 },
  { day: 44, homeSlot: 22, awaySlot: 17 },
  { day: 45, homeSlot: 0, awaySlot: 1 },
  { day: 45, homeSlot: 2, awaySlot: 4 },
  { day: 45, homeSlot: 3, awaySlot: 16 },
  { day: 45, homeSlot: 7, awaySlot: 10 },
  { day: 45, homeSlot: 8, awaySlot: 5 },
  { day: 45, homeSlot: 9, awaySlot: 15 },
  { day: 45, homeSlot: 11, awaySlot: 6 },
  { day: 45, homeSlot: 12, awaySlot: 17 },
  { day: 45, homeSlot: 14, awaySlot: 19 },
  { day: 45, homeSlot: 21, awaySlot: 18 },
  { day: 45, homeSlot: 22, awaySlot: 20 },
  { day: 45, homeSlot: 23, awaySlot: 13 },
  { day: 46, homeSlot: 2, awaySlot: 1 },
  { day: 46, homeSlot: 4, awaySlot: 3 },
  { day: 46, homeSlot: 5, awaySlot: 7 },
  { day: 46, homeSlot: 8, awaySlot: 14 },
  { day: 46, homeSlot: 9, awaySlot: 11 },
  { day: 46, homeSlot: 10, awaySlot: 6 },
  { day: 46, homeSlot: 13, awaySlot: 19 },
  { day: 46, homeSlot: 15, awaySlot: 17 },
  { day: 46, homeSlot: 18, awaySlot: 12 },
  { day: 46, homeSlot: 20, awaySlot: 22 },
  { day: 46, homeSlot: 21, awaySlot: 0 },
  { day: 46, homeSlot: 23, awaySlot: 16 },
  { day: 47, homeSlot: 0, awaySlot: 7 },
  { day: 47, homeSlot: 5, awaySlot: 9 },
  { day: 47, homeSlot: 6, awaySlot: 1 },
  { day: 47, homeSlot: 10, awaySlot: 2 },
  { day: 47, homeSlot: 11, awaySlot: 4 },
  { day: 47, homeSlot: 12, awaySlot: 23 },
  { day: 47, homeSlot: 14, awaySlot: 13 },
  { day: 47, homeSlot: 15, awaySlot: 17 },
  { day: 47, homeSlot: 16, awaySlot: 8 },
  { day: 47, homeSlot: 18, awaySlot: 19 },
  { day: 47, homeSlot: 20, awaySlot: 3 },
  { day: 47, homeSlot: 22, awaySlot: 21 },
  { day: 48, homeSlot: 2, awaySlot: 9 },
  { day: 48, homeSlot: 4, awaySlot: 0 },
  { day: 48, homeSlot: 5, awaySlot: 7 },
  { day: 48, homeSlot: 10, awaySlot: 6 },
  { day: 48, homeSlot: 11, awaySlot: 1 },
  { day: 48, homeSlot: 13, awaySlot: 16 },
  { day: 48, homeSlot: 14, awaySlot: 17 },
  { day: 48, homeSlot: 15, awaySlot: 3 },
  { day: 48, homeSlot: 18, awaySlot: 22 },
  { day: 48, homeSlot: 19, awaySlot: 12 },
  { day: 48, homeSlot: 20, awaySlot: 23 },
  { day: 48, homeSlot: 21, awaySlot: 8 },
  { day: 49, homeSlot: 0, awaySlot: 1 },
  { day: 49, homeSlot: 4, awaySlot: 3 },
  { day: 49, homeSlot: 5, awaySlot: 9 },
  { day: 49, homeSlot: 6, awaySlot: 2 },
  { day: 49, homeSlot: 8, awaySlot: 7 },
  { day: 49, homeSlot: 10, awaySlot: 18 },
  { day: 49, homeSlot: 12, awaySlot: 19 },
  { day: 49, homeSlot: 14, awaySlot: 23 },
  { day: 49, homeSlot: 16, awaySlot: 17 },
  { day: 49, homeSlot: 20, awaySlot: 11 },
  { day: 49, homeSlot: 21, awaySlot: 13 },
  { day: 49, homeSlot: 22, awaySlot: 15 },
  { day: 50, homeSlot: 1, awaySlot: 3 },
  { day: 50, homeSlot: 6, awaySlot: 0 },
  { day: 50, homeSlot: 7, awaySlot: 15 },
  { day: 50, homeSlot: 9, awaySlot: 4 },
  { day: 50, homeSlot: 11, awaySlot: 10 },
  { day: 50, homeSlot: 13, awaySlot: 5 },
  { day: 50, homeSlot: 14, awaySlot: 17 },
  { day: 50, homeSlot: 16, awaySlot: 2 },
  { day: 50, homeSlot: 19, awaySlot: 18 },
  { day: 50, homeSlot: 20, awaySlot: 12 },
  { day: 50, homeSlot: 21, awaySlot: 22 },
  { day: 50, homeSlot: 23, awaySlot: 8 },
  { day: 51, homeSlot: 0, awaySlot: 6 },
  { day: 51, homeSlot: 1, awaySlot: 18 },
  { day: 51, homeSlot: 3, awaySlot: 4 },
  { day: 51, homeSlot: 5, awaySlot: 19 },
  { day: 51, homeSlot: 7, awaySlot: 8 },
  { day: 51, homeSlot: 9, awaySlot: 11 },
  { day: 51, homeSlot: 10, awaySlot: 2 },
  { day: 51, homeSlot: 12, awaySlot: 13 },
  { day: 51, homeSlot: 15, awaySlot: 23 },
  { day: 51, homeSlot: 17, awaySlot: 16 },
  { day: 51, homeSlot: 20, awaySlot: 21 },
  { day: 51, homeSlot: 22, awaySlot: 14 },
  { day: 52, homeSlot: 0, awaySlot: 7 },
  { day: 52, homeSlot: 5, awaySlot: 8 },
  { day: 52, homeSlot: 6, awaySlot: 3 },
  { day: 52, homeSlot: 10, awaySlot: 2 },
  { day: 52, homeSlot: 12, awaySlot: 13 },
  { day: 52, homeSlot: 15, awaySlot: 14 },
  { day: 52, homeSlot: 16, awaySlot: 1 },
  { day: 52, homeSlot: 17, awaySlot: 4 },
  { day: 52, homeSlot: 18, awaySlot: 11 },
  { day: 52, homeSlot: 19, awaySlot: 23 },
  { day: 52, homeSlot: 21, awaySlot: 20 },
  { day: 52, homeSlot: 22, awaySlot: 9 },
  { day: 54, homeSlot: 2, awaySlot: 7 },
  { day: 54, homeSlot: 3, awaySlot: 9 },
  { day: 54, homeSlot: 4, awaySlot: 6 },
  { day: 54, homeSlot: 8, awaySlot: 17 },
  { day: 54, homeSlot: 10, awaySlot: 5 },
  { day: 54, homeSlot: 11, awaySlot: 1 },
  { day: 54, homeSlot: 13, awaySlot: 15 },
  { day: 54, homeSlot: 14, awaySlot: 0 },
  { day: 54, homeSlot: 16, awaySlot: 18 },
  { day: 54, homeSlot: 19, awaySlot: 23 },
  { day: 54, homeSlot: 20, awaySlot: 12 },
  { day: 54, homeSlot: 22, awaySlot: 21 },
  { day: 55, homeSlot: 0, awaySlot: 2 },
  { day: 55, homeSlot: 3, awaySlot: 21 },
  { day: 55, homeSlot: 5, awaySlot: 4 },
  { day: 55, homeSlot: 6, awaySlot: 1 },
  { day: 55, homeSlot: 8, awaySlot: 9 },
  { day: 55, homeSlot: 10, awaySlot: 13 },
  { day: 55, homeSlot: 11, awaySlot: 7 },
  { day: 55, homeSlot: 12, awaySlot: 16 },
  { day: 55, homeSlot: 14, awaySlot: 23 },
  { day: 55, homeSlot: 19, awaySlot: 15 },
  { day: 55, homeSlot: 20, awaySlot: 17 },
  { day: 55, homeSlot: 22, awaySlot: 18 },
  { day: 56, homeSlot: 0, awaySlot: 2 },
  { day: 56, homeSlot: 4, awaySlot: 11 },
  { day: 56, homeSlot: 5, awaySlot: 3 },
  { day: 56, homeSlot: 6, awaySlot: 1 },
  { day: 56, homeSlot: 7, awaySlot: 8 },
  { day: 56, homeSlot: 9, awaySlot: 21 },
  { day: 56, homeSlot: 13, awaySlot: 10 },
  { day: 56, homeSlot: 14, awaySlot: 15 },
  { day: 56, homeSlot: 17, awaySlot: 23 },
  { day: 56, homeSlot: 18, awaySlot: 19 },
  { day: 56, homeSlot: 20, awaySlot: 16 },
  { day: 56, homeSlot: 22, awaySlot: 12 },
  { day: 57, homeSlot: 1, awaySlot: 4 },
  { day: 57, homeSlot: 2, awaySlot: 0 },
  { day: 57, homeSlot: 6, awaySlot: 8 },
  { day: 57, homeSlot: 7, awaySlot: 10 },
  { day: 57, homeSlot: 9, awaySlot: 3 },
  { day: 57, homeSlot: 11, awaySlot: 23 },
  { day: 57, homeSlot: 12, awaySlot: 22 },
  { day: 57, homeSlot: 13, awaySlot: 14 },
  { day: 57, homeSlot: 15, awaySlot: 16 },
  { day: 57, homeSlot: 17, awaySlot: 19 },
  { day: 57, homeSlot: 18, awaySlot: 5 },
  { day: 57, homeSlot: 20, awaySlot: 21 },
  { day: 58, homeSlot: 1, awaySlot: 12 },
  { day: 58, homeSlot: 3, awaySlot: 7 },
  { day: 58, homeSlot: 4, awaySlot: 0 },
  { day: 58, homeSlot: 5, awaySlot: 8 },
  { day: 58, homeSlot: 9, awaySlot: 21 },
  { day: 58, homeSlot: 10, awaySlot: 6 },
  { day: 58, homeSlot: 11, awaySlot: 2 },
  { day: 58, homeSlot: 13, awaySlot: 17 },
  { day: 58, homeSlot: 15, awaySlot: 19 },
  { day: 58, homeSlot: 18, awaySlot: 23 },
  { day: 58, homeSlot: 20, awaySlot: 14 },
  { day: 58, homeSlot: 22, awaySlot: 16 },
  { day: 59, homeSlot: 0, awaySlot: 9 },
  { day: 59, homeSlot: 1, awaySlot: 2 },
  { day: 59, homeSlot: 5, awaySlot: 3 },
  { day: 59, homeSlot: 6, awaySlot: 8 },
  { day: 59, homeSlot: 10, awaySlot: 7 },
  { day: 59, homeSlot: 12, awaySlot: 15 },
  { day: 59, homeSlot: 13, awaySlot: 4 },
  { day: 59, homeSlot: 14, awaySlot: 18 },
  { day: 59, homeSlot: 16, awaySlot: 17 },
  { day: 59, homeSlot: 19, awaySlot: 23 },
  { day: 59, homeSlot: 21, awaySlot: 11 },
  { day: 59, homeSlot: 22, awaySlot: 20 },
  { day: 60, homeSlot: 0, awaySlot: 10 },
  { day: 60, homeSlot: 2, awaySlot: 3 },
  { day: 60, homeSlot: 4, awaySlot: 5 },
  { day: 60, homeSlot: 6, awaySlot: 7 },
  { day: 60, homeSlot: 8, awaySlot: 1 },
  { day: 60, homeSlot: 11, awaySlot: 18 },
  { day: 60, homeSlot: 13, awaySlot: 15 },
  { day: 60, homeSlot: 14, awaySlot: 21 },
  { day: 60, homeSlot: 16, awaySlot: 9 },
  { day: 60, homeSlot: 17, awaySlot: 19 },
  { day: 60, homeSlot: 20, awaySlot: 12 },
  { day: 60, homeSlot: 22, awaySlot: 23 },
  { day: 61, homeSlot: 0, awaySlot: 2 },
  { day: 61, homeSlot: 1, awaySlot: 8 },
  { day: 61, homeSlot: 3, awaySlot: 10 },
  { day: 61, homeSlot: 7, awaySlot: 6 },
  { day: 61, homeSlot: 9, awaySlot: 20 },
  { day: 61, homeSlot: 11, awaySlot: 4 },
  { day: 61, homeSlot: 13, awaySlot: 12 },
  { day: 61, homeSlot: 14, awaySlot: 16 },
  { day: 61, homeSlot: 15, awaySlot: 17 },
  { day: 61, homeSlot: 18, awaySlot: 21 },
  { day: 61, homeSlot: 19, awaySlot: 5 },
  { day: 61, homeSlot: 22, awaySlot: 23 },
  { day: 62, homeSlot: 3, awaySlot: 0 },
  { day: 62, homeSlot: 4, awaySlot: 14 },
  { day: 62, homeSlot: 6, awaySlot: 8 },
  { day: 62, homeSlot: 10, awaySlot: 5 },
  { day: 62, homeSlot: 11, awaySlot: 1 },
  { day: 62, homeSlot: 13, awaySlot: 7 },
  { day: 62, homeSlot: 16, awaySlot: 15 },
  { day: 62, homeSlot: 18, awaySlot: 17 },
  { day: 62, homeSlot: 19, awaySlot: 22 },
  { day: 62, homeSlot: 20, awaySlot: 2 },
  { day: 62, homeSlot: 21, awaySlot: 9 },
  { day: 62, homeSlot: 23, awaySlot: 12 },
  { day: 63, homeSlot: 3, awaySlot: 10 },
  { day: 63, homeSlot: 5, awaySlot: 4 },
  { day: 63, homeSlot: 7, awaySlot: 0 },
  { day: 63, homeSlot: 9, awaySlot: 8 },
  { day: 63, homeSlot: 11, awaySlot: 15 },
  { day: 63, homeSlot: 14, awaySlot: 16 },
  { day: 63, homeSlot: 17, awaySlot: 2 },
  { day: 63, homeSlot: 18, awaySlot: 1 },
  { day: 63, homeSlot: 19, awaySlot: 12 },
  { day: 63, homeSlot: 21, awaySlot: 6 },
  { day: 63, homeSlot: 22, awaySlot: 13 },
  { day: 63, homeSlot: 23, awaySlot: 20 },
  { day: 65, homeSlot: 3, awaySlot: 7 },
  { day: 65, homeSlot: 5, awaySlot: 2 },
  { day: 65, homeSlot: 8, awaySlot: 4 },
  { day: 65, homeSlot: 9, awaySlot: 1 },
  { day: 65, homeSlot: 10, awaySlot: 15 },
  { day: 65, homeSlot: 12, awaySlot: 20 },
  { day: 65, homeSlot: 13, awaySlot: 0 },
  { day: 65, homeSlot: 14, awaySlot: 21 },
  { day: 65, homeSlot: 17, awaySlot: 11 },
  { day: 65, homeSlot: 19, awaySlot: 18 },
  { day: 65, homeSlot: 22, awaySlot: 6 },
  { day: 65, homeSlot: 23, awaySlot: 16 },
  { day: 66, homeSlot: 0, awaySlot: 6 },
  { day: 66, homeSlot: 1, awaySlot: 9 },
  { day: 66, homeSlot: 2, awaySlot: 3 },
  { day: 66, homeSlot: 4, awaySlot: 5 },
  { day: 66, homeSlot: 7, awaySlot: 10 },
  { day: 66, homeSlot: 11, awaySlot: 17 },
  { day: 66, homeSlot: 14, awaySlot: 8 },
  { day: 66, homeSlot: 16, awaySlot: 19 },
  { day: 66, homeSlot: 20, awaySlot: 12 },
  { day: 66, homeSlot: 21, awaySlot: 13 },
  { day: 66, homeSlot: 22, awaySlot: 15 },
  { day: 66, homeSlot: 23, awaySlot: 18 },
  { day: 67, homeSlot: 1, awaySlot: 6 },
  { day: 67, homeSlot: 4, awaySlot: 15 },
  { day: 67, homeSlot: 5, awaySlot: 11 },
  { day: 67, homeSlot: 8, awaySlot: 2 },
  { day: 67, homeSlot: 9, awaySlot: 0 },
  { day: 67, homeSlot: 10, awaySlot: 7 },
  { day: 67, homeSlot: 12, awaySlot: 22 },
  { day: 67, homeSlot: 14, awaySlot: 3 },
  { day: 67, homeSlot: 17, awaySlot: 16 },
  { day: 67, homeSlot: 18, awaySlot: 13 },
  { day: 67, homeSlot: 19, awaySlot: 21 },
  { day: 67, homeSlot: 20, awaySlot: 23 },
  { day: 68, homeSlot: 1, awaySlot: 5 },
  { day: 68, homeSlot: 2, awaySlot: 8 },
  { day: 68, homeSlot: 3, awaySlot: 9 },
  { day: 68, homeSlot: 4, awaySlot: 6 },
  { day: 68, homeSlot: 7, awaySlot: 18 },
  { day: 68, homeSlot: 10, awaySlot: 17 },
  { day: 68, homeSlot: 11, awaySlot: 0 },
  { day: 68, homeSlot: 12, awaySlot: 13 },
  { day: 68, homeSlot: 16, awaySlot: 15 },
  { day: 68, homeSlot: 20, awaySlot: 23 },
  { day: 68, homeSlot: 21, awaySlot: 19 },
  { day: 68, homeSlot: 22, awaySlot: 14 },
  { day: 69, homeSlot: 1, awaySlot: 3 },
  { day: 69, homeSlot: 4, awaySlot: 7 },
  { day: 69, homeSlot: 8, awaySlot: 5 },
  { day: 69, homeSlot: 9, awaySlot: 6 },
  { day: 69, homeSlot: 10, awaySlot: 2 },
  { day: 69, homeSlot: 11, awaySlot: 16 },
  { day: 69, homeSlot: 12, awaySlot: 18 },
  { day: 69, homeSlot: 15, awaySlot: 14 },
  { day: 69, homeSlot: 17, awaySlot: 13 },
  { day: 69, homeSlot: 19, awaySlot: 21 },
  { day: 69, homeSlot: 20, awaySlot: 22 },
  { day: 69, homeSlot: 23, awaySlot: 0 },
  { day: 70, homeSlot: 4, awaySlot: 3 },
  { day: 70, homeSlot: 5, awaySlot: 12 },
  { day: 70, homeSlot: 6, awaySlot: 0 },
  { day: 70, homeSlot: 8, awaySlot: 2 },
  { day: 70, homeSlot: 9, awaySlot: 14 },
  { day: 70, homeSlot: 10, awaySlot: 1 },
  { day: 70, homeSlot: 13, awaySlot: 20 },
  { day: 70, homeSlot: 15, awaySlot: 11 },
  { day: 70, homeSlot: 16, awaySlot: 17 },
  { day: 70, homeSlot: 21, awaySlot: 18 },
  { day: 70, homeSlot: 22, awaySlot: 19 },
  { day: 70, homeSlot: 23, awaySlot: 7 },
  { day: 71, homeSlot: 0, awaySlot: 14 },
  { day: 71, homeSlot: 2, awaySlot: 7 },
  { day: 71, homeSlot: 3, awaySlot: 8 },
  { day: 71, homeSlot: 4, awaySlot: 13 },
  { day: 71, homeSlot: 5, awaySlot: 6 },
  { day: 71, homeSlot: 10, awaySlot: 1 },
  { day: 71, homeSlot: 11, awaySlot: 9 },
  { day: 71, homeSlot: 17, awaySlot: 12 },
  { day: 71, homeSlot: 18, awaySlot: 21 },
  { day: 71, homeSlot: 19, awaySlot: 15 },
  { day: 71, homeSlot: 20, awaySlot: 16 },
  { day: 71, homeSlot: 22, awaySlot: 23 },
  { day: 72, homeSlot: 1, awaySlot: 0 },
  { day: 72, homeSlot: 3, awaySlot: 14 },
  { day: 72, homeSlot: 5, awaySlot: 2 },
  { day: 72, homeSlot: 6, awaySlot: 4 },
  { day: 72, homeSlot: 7, awaySlot: 17 },
  { day: 72, homeSlot: 9, awaySlot: 16 },
  { day: 72, homeSlot: 10, awaySlot: 8 },
  { day: 72, homeSlot: 11, awaySlot: 13 },
  { day: 72, homeSlot: 19, awaySlot: 15 },
  { day: 72, homeSlot: 20, awaySlot: 22 },
  { day: 72, homeSlot: 21, awaySlot: 12 },
  { day: 72, homeSlot: 23, awaySlot: 18 },
  { day: 73, homeSlot: 1, awaySlot: 7 },
  { day: 73, homeSlot: 4, awaySlot: 2 },
  { day: 73, homeSlot: 5, awaySlot: 21 },
  { day: 73, homeSlot: 6, awaySlot: 15 },
  { day: 73, homeSlot: 8, awaySlot: 3 },
  { day: 73, homeSlot: 9, awaySlot: 12 },
  { day: 73, homeSlot: 11, awaySlot: 20 },
  { day: 73, homeSlot: 13, awaySlot: 18 },
  { day: 73, homeSlot: 14, awaySlot: 10 },
  { day: 73, homeSlot: 16, awaySlot: 0 },
  { day: 73, homeSlot: 19, awaySlot: 17 },
  { day: 73, homeSlot: 22, awaySlot: 23 },
  { day: 74, homeSlot: 0, awaySlot: 3 },
  { day: 74, homeSlot: 5, awaySlot: 13 },
  { day: 74, homeSlot: 6, awaySlot: 2 },
  { day: 74, homeSlot: 7, awaySlot: 1 },
  { day: 74, homeSlot: 10, awaySlot: 4 },
  { day: 74, homeSlot: 11, awaySlot: 8 },
  { day: 74, homeSlot: 12, awaySlot: 23 },
  { day: 74, homeSlot: 15, awaySlot: 9 },
  { day: 74, homeSlot: 16, awaySlot: 18 },
  { day: 74, homeSlot: 17, awaySlot: 19 },
  { day: 74, homeSlot: 20, awaySlot: 22 },
  { day: 74, homeSlot: 21, awaySlot: 14 },
  { day: 75, homeSlot: 0, awaySlot: 4 },
  { day: 75, homeSlot: 3, awaySlot: 1 },
  { day: 75, homeSlot: 6, awaySlot: 8 },
  { day: 75, homeSlot: 7, awaySlot: 9 },
  { day: 75, homeSlot: 10, awaySlot: 11 },
  { day: 75, homeSlot: 13, awaySlot: 22 },
  { day: 75, homeSlot: 15, awaySlot: 2 },
  { day: 75, homeSlot: 16, awaySlot: 12 },
  { day: 75, homeSlot: 17, awaySlot: 14 },
  { day: 75, homeSlot: 18, awaySlot: 20 },
  { day: 75, homeSlot: 19, awaySlot: 21 },
  { day: 75, homeSlot: 23, awaySlot: 5 },
  { day: 77, homeSlot: 0, awaySlot: 11 },
  { day: 77, homeSlot: 1, awaySlot: 7 },
  { day: 77, homeSlot: 9, awaySlot: 8 },
  { day: 77, homeSlot: 10, awaySlot: 4 },
  { day: 77, homeSlot: 13, awaySlot: 6 },
  { day: 77, homeSlot: 14, awaySlot: 22 },
  { day: 77, homeSlot: 15, awaySlot: 12 },
  { day: 77, homeSlot: 16, awaySlot: 21 },
  { day: 77, homeSlot: 17, awaySlot: 5 },
  { day: 77, homeSlot: 18, awaySlot: 3 },
  { day: 77, homeSlot: 19, awaySlot: 20 },
  { day: 77, homeSlot: 23, awaySlot: 2 },
  { day: 78, homeSlot: 0, awaySlot: 9 },
  { day: 78, homeSlot: 2, awaySlot: 1 },
  { day: 78, homeSlot: 3, awaySlot: 8 },
  { day: 78, homeSlot: 6, awaySlot: 11 },
  { day: 78, homeSlot: 7, awaySlot: 22 },
  { day: 78, homeSlot: 10, awaySlot: 5 },
  { day: 78, homeSlot: 12, awaySlot: 4 },
  { day: 78, homeSlot: 13, awaySlot: 17 },
  { day: 78, homeSlot: 16, awaySlot: 19 },
  { day: 78, homeSlot: 18, awaySlot: 14 },
  { day: 78, homeSlot: 20, awaySlot: 15 },
  { day: 78, homeSlot: 23, awaySlot: 21 },
  { day: 79, homeSlot: 2, awaySlot: 0 },
  { day: 79, homeSlot: 3, awaySlot: 1 },
  { day: 79, homeSlot: 4, awaySlot: 9 },
  { day: 79, homeSlot: 7, awaySlot: 5 },
  { day: 79, homeSlot: 10, awaySlot: 21 },
  { day: 79, homeSlot: 11, awaySlot: 6 },
  { day: 79, homeSlot: 12, awaySlot: 14 },
  { day: 79, homeSlot: 13, awaySlot: 15 },
  { day: 79, homeSlot: 16, awaySlot: 23 },
  { day: 79, homeSlot: 17, awaySlot: 18 },
  { day: 79, homeSlot: 19, awaySlot: 8 },
  { day: 79, homeSlot: 22, awaySlot: 20 },
  { day: 80, homeSlot: 1, awaySlot: 0 },
  { day: 80, homeSlot: 3, awaySlot: 6 },
  { day: 80, homeSlot: 4, awaySlot: 2 },
  { day: 80, homeSlot: 8, awaySlot: 14 },
  { day: 80, homeSlot: 10, awaySlot: 9 },
  { day: 80, homeSlot: 11, awaySlot: 21 },
  { day: 80, homeSlot: 12, awaySlot: 18 },
  { day: 80, homeSlot: 15, awaySlot: 22 },
  { day: 80, homeSlot: 16, awaySlot: 13 },
  { day: 80, homeSlot: 17, awaySlot: 7 },
  { day: 80, homeSlot: 20, awaySlot: 5 },
  { day: 80, homeSlot: 23, awaySlot: 19 },
  { day: 81, homeSlot: 5, awaySlot: 1 },
  { day: 81, homeSlot: 6, awaySlot: 11 },
  { day: 81, homeSlot: 7, awaySlot: 3 },
  { day: 81, homeSlot: 8, awaySlot: 2 },
  { day: 81, homeSlot: 10, awaySlot: 0 },
  { day: 81, homeSlot: 12, awaySlot: 13 },
  { day: 81, homeSlot: 16, awaySlot: 4 },
  { day: 81, homeSlot: 18, awaySlot: 9 },
  { day: 81, homeSlot: 19, awaySlot: 14 },
  { day: 81, homeSlot: 21, awaySlot: 15 },
  { day: 81, homeSlot: 22, awaySlot: 17 },
  { day: 81, homeSlot: 23, awaySlot: 20 },
  { day: 82, homeSlot: 0, awaySlot: 18 },
  { day: 82, homeSlot: 2, awaySlot: 6 },
  { day: 82, homeSlot: 3, awaySlot: 11 },
  { day: 82, homeSlot: 5, awaySlot: 15 },
  { day: 82, homeSlot: 7, awaySlot: 9 },
  { day: 82, homeSlot: 8, awaySlot: 4 },
  { day: 82, homeSlot: 10, awaySlot: 1 },
  { day: 82, homeSlot: 12, awaySlot: 21 },
  { day: 82, homeSlot: 13, awaySlot: 14 },
  { day: 82, homeSlot: 16, awaySlot: 20 },
  { day: 82, homeSlot: 17, awaySlot: 22 },
  { day: 82, homeSlot: 23, awaySlot: 19 },
  { day: 83, homeSlot: 0, awaySlot: 9 },
  { day: 83, homeSlot: 2, awaySlot: 23 },
  { day: 83, homeSlot: 6, awaySlot: 1 },
  { day: 83, homeSlot: 7, awaySlot: 3 },
  { day: 83, homeSlot: 10, awaySlot: 4 },
  { day: 83, homeSlot: 11, awaySlot: 8 },
  { day: 83, homeSlot: 12, awaySlot: 5 },
  { day: 83, homeSlot: 16, awaySlot: 17 },
  { day: 83, homeSlot: 19, awaySlot: 13 },
  { day: 83, homeSlot: 20, awaySlot: 18 },
  { day: 83, homeSlot: 21, awaySlot: 14 },
  { day: 83, homeSlot: 22, awaySlot: 15 },
  { day: 84, homeSlot: 0, awaySlot: 11 },
  { day: 84, homeSlot: 1, awaySlot: 4 },
  { day: 84, homeSlot: 2, awaySlot: 5 },
  { day: 84, homeSlot: 6, awaySlot: 3 },
  { day: 84, homeSlot: 8, awaySlot: 7 },
  { day: 84, homeSlot: 10, awaySlot: 9 },
  { day: 84, homeSlot: 13, awaySlot: 15 },
  { day: 84, homeSlot: 14, awaySlot: 12 },
  { day: 84, homeSlot: 16, awaySlot: 22 },
  { day: 84, homeSlot: 17, awaySlot: 21 },
  { day: 84, homeSlot: 18, awaySlot: 23 },
  { day: 84, homeSlot: 19, awaySlot: 20 },
  { day: 85, homeSlot: 1, awaySlot: 20 },
  { day: 85, homeSlot: 4, awaySlot: 6 },
  { day: 85, homeSlot: 9, awaySlot: 2 },
  { day: 85, homeSlot: 10, awaySlot: 8 },
  { day: 85, homeSlot: 11, awaySlot: 7 },
  { day: 85, homeSlot: 13, awaySlot: 18 },
  { day: 85, homeSlot: 14, awaySlot: 0 },
  { day: 85, homeSlot: 16, awaySlot: 12 },
  { day: 85, homeSlot: 17, awaySlot: 23 },
  { day: 85, homeSlot: 19, awaySlot: 3 },
  { day: 85, homeSlot: 21, awaySlot: 15 },
  { day: 85, homeSlot: 22, awaySlot: 5 },
  { day: 86, homeSlot: 0, awaySlot: 8 },
  { day: 86, homeSlot: 1, awaySlot: 19 },
  { day: 86, homeSlot: 2, awaySlot: 14 },
  { day: 86, homeSlot: 4, awaySlot: 7 },
  { day: 86, homeSlot: 5, awaySlot: 9 },
  { day: 86, homeSlot: 6, awaySlot: 10 },
  { day: 86, homeSlot: 11, awaySlot: 3 },
  { day: 86, homeSlot: 12, awaySlot: 13 },
  { day: 86, homeSlot: 15, awaySlot: 22 },
  { day: 86, homeSlot: 20, awaySlot: 18 },
  { day: 86, homeSlot: 21, awaySlot: 17 },
  { day: 86, homeSlot: 23, awaySlot: 16 },
  { day: 88, homeSlot: 0, awaySlot: 5 },
  { day: 88, homeSlot: 1, awaySlot: 10 },
  { day: 88, homeSlot: 3, awaySlot: 8 },
  { day: 88, homeSlot: 4, awaySlot: 2 },
  { day: 88, homeSlot: 7, awaySlot: 11 },
  { day: 88, homeSlot: 14, awaySlot: 13 },
  { day: 88, homeSlot: 15, awaySlot: 6 },
  { day: 88, homeSlot: 16, awaySlot: 19 },
  { day: 88, homeSlot: 17, awaySlot: 12 },
  { day: 88, homeSlot: 18, awaySlot: 23 },
  { day: 88, homeSlot: 20, awaySlot: 22 },
  { day: 89, homeSlot: 0, awaySlot: 6 },
  { day: 89, homeSlot: 1, awaySlot: 9 },
  { day: 89, homeSlot: 3, awaySlot: 7 },
  { day: 89, homeSlot: 4, awaySlot: 12 },
  { day: 89, homeSlot: 5, awaySlot: 2 },
  { day: 89, homeSlot: 10, awaySlot: 14 },
  { day: 89, homeSlot: 11, awaySlot: 8 },
  { day: 89, homeSlot: 13, awaySlot: 21 },
  { day: 89, homeSlot: 15, awaySlot: 19 },
  { day: 89, homeSlot: 16, awaySlot: 22 },
  { day: 89, homeSlot: 17, awaySlot: 20 },
  { day: 89, homeSlot: 18, awaySlot: 23 },
  { day: 90, homeSlot: 0, awaySlot: 4 },
  { day: 90, homeSlot: 3, awaySlot: 15 },
  { day: 90, homeSlot: 5, awaySlot: 8 },
  { day: 90, homeSlot: 6, awaySlot: 19 },
  { day: 90, homeSlot: 7, awaySlot: 2 },
  { day: 90, homeSlot: 10, awaySlot: 9 },
  { day: 90, homeSlot: 11, awaySlot: 12 },
  { day: 90, homeSlot: 14, awaySlot: 13 },
  { day: 90, homeSlot: 16, awaySlot: 1 },
  { day: 90, homeSlot: 21, awaySlot: 20 },
  { day: 90, homeSlot: 22, awaySlot: 18 },
  { day: 90, homeSlot: 23, awaySlot: 17 },
  { day: 91, homeSlot: 0, awaySlot: 22 },
  { day: 91, homeSlot: 2, awaySlot: 17 },
  { day: 91, homeSlot: 3, awaySlot: 1 },
  { day: 91, homeSlot: 4, awaySlot: 7 },
  { day: 91, homeSlot: 5, awaySlot: 11 },
  { day: 91, homeSlot: 8, awaySlot: 6 },
  { day: 91, homeSlot: 9, awaySlot: 10 },
  { day: 91, homeSlot: 13, awaySlot: 12 },
  { day: 91, homeSlot: 14, awaySlot: 23 },
  { day: 91, homeSlot: 15, awaySlot: 20 },
  { day: 91, homeSlot: 18, awaySlot: 16 },
  { day: 91, homeSlot: 19, awaySlot: 21 },
  { day: 92, homeSlot: 0, awaySlot: 3 },
  { day: 92, homeSlot: 2, awaySlot: 11 },
  { day: 92, homeSlot: 6, awaySlot: 22 },
  { day: 92, homeSlot: 7, awaySlot: 10 },
  { day: 92, homeSlot: 8, awaySlot: 1 },
  { day: 92, homeSlot: 9, awaySlot: 5 },
  { day: 92, homeSlot: 13, awaySlot: 19 },
  { day: 92, homeSlot: 14, awaySlot: 16 },
  { day: 92, homeSlot: 15, awaySlot: 12 },
  { day: 92, homeSlot: 17, awaySlot: 18 },
  { day: 92, homeSlot: 20, awaySlot: 23 },
  { day: 92, homeSlot: 21, awaySlot: 4 },
  { day: 93, homeSlot: 1, awaySlot: 0 },
  { day: 93, homeSlot: 3, awaySlot: 6 },
  { day: 93, homeSlot: 4, awaySlot: 7 },
  { day: 93, homeSlot: 8, awaySlot: 22 },
  { day: 93, homeSlot: 9, awaySlot: 10 },
  { day: 93, homeSlot: 11, awaySlot: 5 },
  { day: 93, homeSlot: 12, awaySlot: 14 },
  { day: 93, homeSlot: 13, awaySlot: 20 },
  { day: 93, homeSlot: 15, awaySlot: 23 },
  { day: 93, homeSlot: 16, awaySlot: 2 },
  { day: 93, homeSlot: 19, awaySlot: 17 },
  { day: 93, homeSlot: 21, awaySlot: 18 },
  { day: 94, homeSlot: 0, awaySlot: 10 },
  { day: 94, homeSlot: 2, awaySlot: 8 },
  { day: 94, homeSlot: 3, awaySlot: 11 },
  { day: 94, homeSlot: 4, awaySlot: 1 },
  { day: 94, homeSlot: 7, awaySlot: 6 },
  { day: 94, homeSlot: 9, awaySlot: 18 },
  { day: 94, homeSlot: 12, awaySlot: 16 },
  { day: 94, homeSlot: 14, awaySlot: 5 },
  { day: 94, homeSlot: 15, awaySlot: 13 },
  { day: 94, homeSlot: 17, awaySlot: 19 },
  { day: 94, homeSlot: 21, awaySlot: 20 },
  { day: 94, homeSlot: 23, awaySlot: 22 },
  { day: 95, homeSlot: 1, awaySlot: 2 },
  { day: 95, homeSlot: 4, awaySlot: 8 },
  { day: 95, homeSlot: 5, awaySlot: 3 },
  { day: 95, homeSlot: 6, awaySlot: 0 },
  { day: 95, homeSlot: 10, awaySlot: 12 },
  { day: 95, homeSlot: 11, awaySlot: 9 },
  { day: 95, homeSlot: 14, awaySlot: 21 },
  { day: 95, homeSlot: 15, awaySlot: 17 },
  { day: 95, homeSlot: 16, awaySlot: 23 },
  { day: 95, homeSlot: 19, awaySlot: 18 },
  { day: 95, homeSlot: 20, awaySlot: 13 },
  { day: 95, homeSlot: 22, awaySlot: 7 },
  { day: 96, homeSlot: 1, awaySlot: 3 },
  { day: 96, homeSlot: 2, awaySlot: 6 },
  { day: 96, homeSlot: 4, awaySlot: 10 },
  { day: 96, homeSlot: 7, awaySlot: 20 },
  { day: 96, homeSlot: 8, awaySlot: 9 },
  { day: 96, homeSlot: 11, awaySlot: 0 },
  { day: 96, homeSlot: 13, awaySlot: 17 },
  { day: 96, homeSlot: 15, awaySlot: 14 },
  { day: 96, homeSlot: 16, awaySlot: 23 },
  { day: 96, homeSlot: 18, awaySlot: 12 },
  { day: 96, homeSlot: 19, awaySlot: 22 },
  { day: 96, homeSlot: 21, awaySlot: 5 },
  { day: 97, homeSlot: 2, awaySlot: 0 },
  { day: 97, homeSlot: 4, awaySlot: 1 },
  { day: 97, homeSlot: 8, awaySlot: 7 },
  { day: 97, homeSlot: 9, awaySlot: 11 },
  { day: 97, homeSlot: 10, awaySlot: 3 },
  { day: 97, homeSlot: 13, awaySlot: 19 },
  { day: 97, homeSlot: 14, awaySlot: 6 },
  { day: 97, homeSlot: 16, awaySlot: 15 },
  { day: 97, homeSlot: 17, awaySlot: 20 },
  { day: 97, homeSlot: 18, awaySlot: 5 },
  { day: 97, homeSlot: 21, awaySlot: 12 },
  { day: 97, homeSlot: 22, awaySlot: 23 },
  { day: 99, homeSlot: 1, awaySlot: 13 },
  { day: 99, homeSlot: 3, awaySlot: 0 },
  { day: 99, homeSlot: 4, awaySlot: 20 },
  { day: 99, homeSlot: 6, awaySlot: 18 },
  { day: 99, homeSlot: 8, awaySlot: 17 },
  { day: 99, homeSlot: 9, awaySlot: 7 },
  { day: 99, homeSlot: 11, awaySlot: 5 },
  { day: 99, homeSlot: 12, awaySlot: 2 },
  { day: 99, homeSlot: 14, awaySlot: 21 },
  { day: 99, homeSlot: 15, awaySlot: 16 },
  { day: 99, homeSlot: 19, awaySlot: 22 },
  { day: 99, homeSlot: 23, awaySlot: 10 },
  { day: 100, homeSlot: 1, awaySlot: 5 },
  { day: 100, homeSlot: 2, awaySlot: 12 },
  { day: 100, homeSlot: 4, awaySlot: 7 },
  { day: 100, homeSlot: 6, awaySlot: 10 },
  { day: 100, homeSlot: 8, awaySlot: 3 },
  { day: 100, homeSlot: 11, awaySlot: 9 },
  { day: 100, homeSlot: 14, awaySlot: 13 },
  { day: 100, homeSlot: 15, awaySlot: 22 },
  { day: 100, homeSlot: 18, awaySlot: 0 },
  { day: 100, homeSlot: 19, awaySlot: 17 },
  { day: 100, homeSlot: 20, awaySlot: 23 },
  { day: 100, homeSlot: 21, awaySlot: 16 },
  { day: 101, homeSlot: 4, awaySlot: 3 },
  { day: 101, homeSlot: 5, awaySlot: 6 },
  { day: 101, homeSlot: 7, awaySlot: 15 },
  { day: 101, homeSlot: 9, awaySlot: 1 },
  { day: 101, homeSlot: 10, awaySlot: 0 },
  { day: 101, homeSlot: 11, awaySlot: 2 },
  { day: 101, homeSlot: 12, awaySlot: 21 },
  { day: 101, homeSlot: 13, awaySlot: 22 },
  { day: 101, homeSlot: 14, awaySlot: 20 },
  { day: 101, homeSlot: 17, awaySlot: 8 },
  { day: 101, homeSlot: 18, awaySlot: 16 },
  { day: 101, homeSlot: 19, awaySlot: 23 },
  { day: 102, homeSlot: 0, awaySlot: 11 },
  { day: 102, homeSlot: 1, awaySlot: 10 },
  { day: 102, homeSlot: 2, awaySlot: 9 },
  { day: 102, homeSlot: 3, awaySlot: 12 },
  { day: 102, homeSlot: 5, awaySlot: 7 },
  { day: 102, homeSlot: 6, awaySlot: 4 },
  { day: 102, homeSlot: 8, awaySlot: 15 },
  { day: 102, homeSlot: 13, awaySlot: 16 },
  { day: 102, homeSlot: 14, awaySlot: 23 },
  { day: 102, homeSlot: 17, awaySlot: 20 },
  { day: 102, homeSlot: 18, awaySlot: 21 },
  { day: 102, homeSlot: 22, awaySlot: 19 },
  { day: 103, homeSlot: 2, awaySlot: 15 },
  { day: 103, homeSlot: 5, awaySlot: 17 },
  { day: 103, homeSlot: 6, awaySlot: 0 },
  { day: 103, homeSlot: 7, awaySlot: 19 },
  { day: 103, homeSlot: 11, awaySlot: 3 },
  { day: 103, homeSlot: 12, awaySlot: 14 },
  { day: 103, homeSlot: 16, awaySlot: 13 },
  { day: 103, homeSlot: 18, awaySlot: 10 },
  { day: 103, homeSlot: 20, awaySlot: 1 },
  { day: 103, homeSlot: 22, awaySlot: 8 },
  { day: 103, homeSlot: 23, awaySlot: 4 },
  { day: 104, homeSlot: 2, awaySlot: 11 },
  { day: 104, homeSlot: 4, awaySlot: 3 },
  { day: 104, homeSlot: 6, awaySlot: 5 },
  { day: 104, homeSlot: 9, awaySlot: 8 },
  { day: 104, homeSlot: 10, awaySlot: 22 },
  { day: 104, homeSlot: 13, awaySlot: 18 },
  { day: 104, homeSlot: 15, awaySlot: 0 },
  { day: 104, homeSlot: 16, awaySlot: 14 },
  { day: 104, homeSlot: 17, awaySlot: 12 },
  { day: 104, homeSlot: 19, awaySlot: 7 },
  { day: 104, homeSlot: 21, awaySlot: 1 },
  { day: 104, homeSlot: 23, awaySlot: 20 },
  { day: 105, homeSlot: 0, awaySlot: 4 },
  { day: 105, homeSlot: 1, awaySlot: 8 },
  { day: 105, homeSlot: 2, awaySlot: 13 },
  { day: 105, homeSlot: 3, awaySlot: 17 },
  { day: 105, homeSlot: 5, awaySlot: 7 },
  { day: 105, homeSlot: 11, awaySlot: 9 },
  { day: 105, homeSlot: 12, awaySlot: 10 },
  { day: 105, homeSlot: 16, awaySlot: 15 },
  { day: 105, homeSlot: 18, awaySlot: 14 },
  { day: 105, homeSlot: 19, awaySlot: 22 },
  { day: 105, homeSlot: 20, awaySlot: 6 },
  { day: 105, homeSlot: 21, awaySlot: 23 },
  { day: 106, homeSlot: 0, awaySlot: 11 },
  { day: 106, homeSlot: 1, awaySlot: 14 },
  { day: 106, homeSlot: 4, awaySlot: 21 },
  { day: 106, homeSlot: 5, awaySlot: 9 },
  { day: 106, homeSlot: 6, awaySlot: 12 },
  { day: 106, homeSlot: 7, awaySlot: 3 },
  { day: 106, homeSlot: 8, awaySlot: 10 },
  { day: 106, homeSlot: 16, awaySlot: 15 },
  { day: 106, homeSlot: 17, awaySlot: 13 },
  { day: 106, homeSlot: 19, awaySlot: 2 },
  { day: 106, homeSlot: 20, awaySlot: 22 },
  { day: 106, homeSlot: 23, awaySlot: 18 },
  { day: 107, homeSlot: 2, awaySlot: 9 },
  { day: 107, homeSlot: 3, awaySlot: 1 },
  { day: 107, homeSlot: 5, awaySlot: 0 },
  { day: 107, homeSlot: 7, awaySlot: 16 },
  { day: 107, homeSlot: 8, awaySlot: 11 },
  { day: 107, homeSlot: 10, awaySlot: 6 },
  { day: 107, homeSlot: 14, awaySlot: 18 },
  { day: 107, homeSlot: 15, awaySlot: 17 },
  { day: 107, homeSlot: 19, awaySlot: 13 },
  { day: 107, homeSlot: 20, awaySlot: 4 },
  { day: 107, homeSlot: 21, awaySlot: 23 },
  { day: 107, homeSlot: 22, awaySlot: 12 },
  { day: 108, homeSlot: 0, awaySlot: 20 },
  { day: 108, homeSlot: 6, awaySlot: 5 },
  { day: 108, homeSlot: 7, awaySlot: 4 },
  { day: 108, homeSlot: 8, awaySlot: 1 },
  { day: 108, homeSlot: 9, awaySlot: 23 },
  { day: 108, homeSlot: 10, awaySlot: 22 },
  { day: 108, homeSlot: 12, awaySlot: 19 },
  { day: 108, homeSlot: 13, awaySlot: 2 },
  { day: 108, homeSlot: 15, awaySlot: 14 },
  { day: 108, homeSlot: 16, awaySlot: 3 },
  { day: 108, homeSlot: 18, awaySlot: 17 },
  { day: 110, homeSlot: 2, awaySlot: 8 },
  { day: 110, homeSlot: 5, awaySlot: 4 },
  { day: 110, homeSlot: 6, awaySlot: 0 },
  { day: 110, homeSlot: 7, awaySlot: 1 },
  { day: 110, homeSlot: 10, awaySlot: 20 },
  { day: 110, homeSlot: 11, awaySlot: 3 },
  { day: 110, homeSlot: 12, awaySlot: 14 },
  { day: 110, homeSlot: 13, awaySlot: 9 },
  { day: 110, homeSlot: 17, awaySlot: 15 },
  { day: 110, homeSlot: 19, awaySlot: 23 },
  { day: 110, homeSlot: 21, awaySlot: 18 },
  { day: 110, homeSlot: 22, awaySlot: 16 },
  { day: 111, homeSlot: 0, awaySlot: 15 },
  { day: 111, homeSlot: 2, awaySlot: 1 },
  { day: 111, homeSlot: 3, awaySlot: 14 },
  { day: 111, homeSlot: 4, awaySlot: 10 },
  { day: 111, homeSlot: 8, awaySlot: 5 },
  { day: 111, homeSlot: 9, awaySlot: 6 },
  { day: 111, homeSlot: 13, awaySlot: 12 },
  { day: 111, homeSlot: 17, awaySlot: 16 },
  { day: 111, homeSlot: 18, awaySlot: 22 },
  { day: 111, homeSlot: 20, awaySlot: 7 },
  { day: 111, homeSlot: 23, awaySlot: 19 },
  { day: 112, homeSlot: 0, awaySlot: 7 },
  { day: 112, homeSlot: 1, awaySlot: 9 },
  { day: 112, homeSlot: 2, awaySlot: 4 },
  { day: 112, homeSlot: 3, awaySlot: 5 },
  { day: 112, homeSlot: 8, awaySlot: 6 },
  { day: 112, homeSlot: 11, awaySlot: 10 },
  { day: 112, homeSlot: 12, awaySlot: 22 },
  { day: 112, homeSlot: 14, awaySlot: 16 },
  { day: 112, homeSlot: 18, awaySlot: 17 },
  { day: 112, homeSlot: 19, awaySlot: 13 },
  { day: 112, homeSlot: 20, awaySlot: 21 },
  { day: 112, homeSlot: 23, awaySlot: 15 },
  { day: 113, homeSlot: 3, awaySlot: 0 },
  { day: 113, homeSlot: 5, awaySlot: 4 },
  { day: 113, homeSlot: 6, awaySlot: 16 },
  { day: 113, homeSlot: 8, awaySlot: 12 },
  { day: 113, homeSlot: 9, awaySlot: 1 },
  { day: 113, homeSlot: 11, awaySlot: 7 },
  { day: 113, homeSlot: 14, awaySlot: 13 },
  { day: 113, homeSlot: 15, awaySlot: 19 },
  { day: 113, homeSlot: 17, awaySlot: 23 },
  { day: 113, homeSlot: 20, awaySlot: 18 },
  { day: 113, homeSlot: 21, awaySlot: 10 },
  { day: 113, homeSlot: 22, awaySlot: 2 },
  { day: 114, homeSlot: 2, awaySlot: 9 },
  { day: 114, homeSlot: 4, awaySlot: 11 },
  { day: 114, homeSlot: 5, awaySlot: 10 },
  { day: 114, homeSlot: 6, awaySlot: 14 },
  { day: 114, homeSlot: 7, awaySlot: 3 },
  { day: 114, homeSlot: 8, awaySlot: 19 },
  { day: 114, homeSlot: 13, awaySlot: 23 },
  { day: 114, homeSlot: 15, awaySlot: 16 },
  { day: 114, homeSlot: 17, awaySlot: 0 },
  { day: 114, homeSlot: 18, awaySlot: 21 },
  { day: 114, homeSlot: 20, awaySlot: 1 },
  { day: 114, homeSlot: 22, awaySlot: 12 },
  { day: 115, homeSlot: 2, awaySlot: 14 },
  { day: 115, homeSlot: 4, awaySlot: 12 },
  { day: 115, homeSlot: 6, awaySlot: 1 },
  { day: 115, homeSlot: 8, awaySlot: 13 },
  { day: 115, homeSlot: 9, awaySlot: 7 },
  { day: 115, homeSlot: 10, awaySlot: 3 },
  { day: 115, homeSlot: 17, awaySlot: 16 },
  { day: 115, homeSlot: 19, awaySlot: 5 },
  { day: 115, homeSlot: 20, awaySlot: 0 },
  { day: 115, homeSlot: 22, awaySlot: 18 },
  { day: 115, homeSlot: 23, awaySlot: 15 },
  { day: 116, homeSlot: 0, awaySlot: 8 },
  { day: 116, homeSlot: 2, awaySlot: 3 },
  { day: 116, homeSlot: 4, awaySlot: 6 },
  { day: 116, homeSlot: 5, awaySlot: 1 },
  { day: 116, homeSlot: 10, awaySlot: 9 },
  { day: 116, homeSlot: 11, awaySlot: 7 },
  { day: 116, homeSlot: 12, awaySlot: 23 },
  { day: 116, homeSlot: 15, awaySlot: 18 },
  { day: 116, homeSlot: 16, awaySlot: 14 },
  { day: 116, homeSlot: 19, awaySlot: 17 },
  { day: 116, homeSlot: 20, awaySlot: 21 },
  { day: 116, homeSlot: 22, awaySlot: 13 },
  { day: 117, homeSlot: 0, awaySlot: 3 },
  { day: 117, homeSlot: 4, awaySlot: 8 },
  { day: 117, homeSlot: 5, awaySlot: 2 },
  { day: 117, homeSlot: 10, awaySlot: 9 },
  { day: 117, homeSlot: 11, awaySlot: 6 },
  { day: 117, homeSlot: 12, awaySlot: 16 },
  { day: 117, homeSlot: 13, awaySlot: 18 },
  { day: 117, homeSlot: 14, awaySlot: 21 },
  { day: 117, homeSlot: 17, awaySlot: 15 },
  { day: 117, homeSlot: 19, awaySlot: 20 },
  { day: 117, homeSlot: 22, awaySlot: 7 },
  { day: 117, homeSlot: 23, awaySlot: 1 },
  { day: 118, homeSlot: 0, awaySlot: 9 },
  { day: 118, homeSlot: 2, awaySlot: 10 },
  { day: 118, homeSlot: 4, awaySlot: 13 },
  { day: 118, homeSlot: 5, awaySlot: 11 },
  { day: 118, homeSlot: 6, awaySlot: 7 },
  { day: 118, homeSlot: 8, awaySlot: 20 },
  { day: 118, homeSlot: 14, awaySlot: 22 },
  { day: 118, homeSlot: 15, awaySlot: 1 },
  { day: 118, homeSlot: 17, awaySlot: 3 },
  { day: 118, homeSlot: 19, awaySlot: 12 },
  { day: 118, homeSlot: 21, awaySlot: 16 },
  { day: 118, homeSlot: 23, awaySlot: 18 },
  { day: 119, homeSlot: 1, awaySlot: 5 },
  { day: 119, homeSlot: 6, awaySlot: 3 },
  { day: 119, homeSlot: 8, awaySlot: 11 },
  { day: 119, homeSlot: 9, awaySlot: 10 },
  { day: 119, homeSlot: 12, awaySlot: 20 },
  { day: 119, homeSlot: 14, awaySlot: 7 },
  { day: 119, homeSlot: 15, awaySlot: 0 },
  { day: 119, homeSlot: 17, awaySlot: 16 },
  { day: 119, homeSlot: 18, awaySlot: 13 },
  { day: 119, homeSlot: 21, awaySlot: 19 },
  { day: 119, homeSlot: 22, awaySlot: 2 },
  { day: 119, homeSlot: 23, awaySlot: 4 },
  { day: 120, homeSlot: 3, awaySlot: 1 },
  { day: 120, homeSlot: 7, awaySlot: 4 },
  { day: 120, homeSlot: 8, awaySlot: 5 },
  { day: 120, homeSlot: 9, awaySlot: 0 },
  { day: 120, homeSlot: 10, awaySlot: 2 },
  { day: 120, homeSlot: 11, awaySlot: 18 },
  { day: 120, homeSlot: 13, awaySlot: 12 },
  { day: 120, homeSlot: 14, awaySlot: 15 },
  { day: 120, homeSlot: 16, awaySlot: 21 },
  { day: 120, homeSlot: 20, awaySlot: 6 },
  { day: 120, homeSlot: 22, awaySlot: 19 },
  { day: 120, homeSlot: 23, awaySlot: 17 },
  { day: 122, homeSlot: 3, awaySlot: 0 },
  { day: 122, homeSlot: 4, awaySlot: 1 },
  { day: 122, homeSlot: 5, awaySlot: 11 },
  { day: 122, homeSlot: 9, awaySlot: 2 },
  { day: 122, homeSlot: 10, awaySlot: 7 },
  { day: 122, homeSlot: 12, awaySlot: 13 },
  { day: 122, homeSlot: 14, awaySlot: 20 },
  { day: 122, homeSlot: 15, awaySlot: 22 },
  { day: 122, homeSlot: 16, awaySlot: 21 },
  { day: 122, homeSlot: 17, awaySlot: 6 },
  { day: 122, homeSlot: 18, awaySlot: 8 },
  { day: 122, homeSlot: 19, awaySlot: 23 },
  { day: 123, homeSlot: 0, awaySlot: 2 },
  { day: 123, homeSlot: 4, awaySlot: 10 },
  { day: 123, homeSlot: 7, awaySlot: 6 },
  { day: 123, homeSlot: 8, awaySlot: 3 },
  { day: 123, homeSlot: 9, awaySlot: 5 },
  { day: 123, homeSlot: 12, awaySlot: 17 },
  { day: 123, homeSlot: 13, awaySlot: 21 },
  { day: 123, homeSlot: 16, awaySlot: 11 },
  { day: 123, homeSlot: 18, awaySlot: 14 },
  { day: 123, homeSlot: 19, awaySlot: 1 },
  { day: 123, homeSlot: 20, awaySlot: 15 },
  { day: 123, homeSlot: 22, awaySlot: 23 },
  { day: 124, homeSlot: 0, awaySlot: 3 },
  { day: 124, homeSlot: 1, awaySlot: 4 },
  { day: 124, homeSlot: 2, awaySlot: 21 },
  { day: 124, homeSlot: 8, awaySlot: 7 },
  { day: 124, homeSlot: 10, awaySlot: 6 },
  { day: 124, homeSlot: 11, awaySlot: 9 },
  { day: 124, homeSlot: 15, awaySlot: 20 },
  { day: 124, homeSlot: 16, awaySlot: 13 },
  { day: 124, homeSlot: 17, awaySlot: 12 },
  { day: 124, homeSlot: 19, awaySlot: 18 },
  { day: 124, homeSlot: 22, awaySlot: 14 },
  { day: 124, homeSlot: 23, awaySlot: 5 },
  { day: 125, homeSlot: 0, awaySlot: 19 },
  { day: 125, homeSlot: 1, awaySlot: 11 },
  { day: 125, homeSlot: 4, awaySlot: 3 },
  { day: 125, homeSlot: 6, awaySlot: 20 },
  { day: 125, homeSlot: 7, awaySlot: 5 },
  { day: 125, homeSlot: 8, awaySlot: 13 },
  { day: 125, homeSlot: 9, awaySlot: 17 },
  { day: 125, homeSlot: 10, awaySlot: 23 },
  { day: 125, homeSlot: 15, awaySlot: 14 },
  { day: 125, homeSlot: 16, awaySlot: 12 },
  { day: 125, homeSlot: 22, awaySlot: 18 },
  { day: 126, homeSlot: 1, awaySlot: 4 },
  { day: 126, homeSlot: 3, awaySlot: 2 },
  { day: 126, homeSlot: 6, awaySlot: 5 },
  { day: 126, homeSlot: 7, awaySlot: 14 },
  { day: 126, homeSlot: 8, awaySlot: 0 },
  { day: 126, homeSlot: 11, awaySlot: 10 },
  { day: 126, homeSlot: 12, awaySlot: 17 },
  { day: 126, homeSlot: 15, awaySlot: 13 },
  { day: 126, homeSlot: 16, awaySlot: 20 },
  { day: 126, homeSlot: 19, awaySlot: 9 },
  { day: 126, homeSlot: 22, awaySlot: 18 },
  { day: 126, homeSlot: 23, awaySlot: 21 },
  { day: 127, homeSlot: 0, awaySlot: 7 },
  { day: 127, homeSlot: 1, awaySlot: 11 },
  { day: 127, homeSlot: 5, awaySlot: 3 },
  { day: 127, homeSlot: 8, awaySlot: 12 },
  { day: 127, homeSlot: 10, awaySlot: 15 },
  { day: 127, homeSlot: 13, awaySlot: 16 },
  { day: 127, homeSlot: 14, awaySlot: 4 },
  { day: 127, homeSlot: 18, awaySlot: 22 },
  { day: 127, homeSlot: 19, awaySlot: 6 },
  { day: 127, homeSlot: 21, awaySlot: 20 },
  { day: 127, homeSlot: 23, awaySlot: 17 },
  { day: 128, homeSlot: 3, awaySlot: 9 },
  { day: 128, homeSlot: 5, awaySlot: 4 },
  { day: 128, homeSlot: 6, awaySlot: 16 },
  { day: 128, homeSlot: 7, awaySlot: 17 },
  { day: 128, homeSlot: 8, awaySlot: 2 },
  { day: 128, homeSlot: 10, awaySlot: 0 },
  { day: 128, homeSlot: 11, awaySlot: 1 },
  { day: 128, homeSlot: 13, awaySlot: 12 },
  { day: 128, homeSlot: 18, awaySlot: 15 },
  { day: 128, homeSlot: 20, awaySlot: 14 },
  { day: 128, homeSlot: 21, awaySlot: 22 },
  { day: 128, homeSlot: 23, awaySlot: 19 },
  { day: 129, homeSlot: 0, awaySlot: 17 },
  { day: 129, homeSlot: 1, awaySlot: 2 },
  { day: 129, homeSlot: 5, awaySlot: 4 },
  { day: 129, homeSlot: 7, awaySlot: 6 },
  { day: 129, homeSlot: 8, awaySlot: 9 },
  { day: 129, homeSlot: 11, awaySlot: 14 },
  { day: 129, homeSlot: 13, awaySlot: 23 },
  { day: 129, homeSlot: 15, awaySlot: 10 },
  { day: 129, homeSlot: 19, awaySlot: 16 },
  { day: 129, homeSlot: 20, awaySlot: 12 },
  { day: 129, homeSlot: 21, awaySlot: 3 },
  { day: 129, homeSlot: 22, awaySlot: 18 },
  { day: 130, homeSlot: 1, awaySlot: 11 },
  { day: 130, homeSlot: 4, awaySlot: 2 },
  { day: 130, homeSlot: 5, awaySlot: 0 },
  { day: 130, homeSlot: 8, awaySlot: 6 },
  { day: 130, homeSlot: 9, awaySlot: 12 },
  { day: 130, homeSlot: 14, awaySlot: 17 },
  { day: 130, homeSlot: 15, awaySlot: 13 },
  { day: 130, homeSlot: 16, awaySlot: 3 },
  { day: 130, homeSlot: 20, awaySlot: 18 },
  { day: 130, homeSlot: 21, awaySlot: 7 },
  { day: 130, homeSlot: 22, awaySlot: 19 },
  { day: 131, homeSlot: 0, awaySlot: 2 },
  { day: 131, homeSlot: 1, awaySlot: 6 },
  { day: 131, homeSlot: 4, awaySlot: 10 },
  { day: 131, homeSlot: 5, awaySlot: 12 },
  { day: 131, homeSlot: 8, awaySlot: 20 },
  { day: 131, homeSlot: 9, awaySlot: 3 },
  { day: 131, homeSlot: 11, awaySlot: 7 },
  { day: 131, homeSlot: 13, awaySlot: 21 },
  { day: 131, homeSlot: 14, awaySlot: 18 },
  { day: 131, homeSlot: 15, awaySlot: 19 },
  { day: 131, homeSlot: 17, awaySlot: 16 },
  { day: 131, homeSlot: 23, awaySlot: 22 },
  { day: 133, homeSlot: 2, awaySlot: 0 },
  { day: 133, homeSlot: 3, awaySlot: 19 },
  { day: 133, homeSlot: 4, awaySlot: 1 },
  { day: 133, homeSlot: 5, awaySlot: 7 },
  { day: 133, homeSlot: 9, awaySlot: 6 },
  { day: 133, homeSlot: 11, awaySlot: 10 },
  { day: 133, homeSlot: 12, awaySlot: 8 },
  { day: 133, homeSlot: 13, awaySlot: 23 },
  { day: 133, homeSlot: 14, awaySlot: 20 },
  { day: 133, homeSlot: 16, awaySlot: 22 },
  { day: 133, homeSlot: 17, awaySlot: 15 },
  { day: 133, homeSlot: 21, awaySlot: 18 },
  { day: 134, homeSlot: 0, awaySlot: 3 },
  { day: 134, homeSlot: 1, awaySlot: 6 },
  { day: 134, homeSlot: 9, awaySlot: 4 },
  { day: 134, homeSlot: 10, awaySlot: 8 },
  { day: 134, homeSlot: 11, awaySlot: 7 },
  { day: 134, homeSlot: 13, awaySlot: 21 },
  { day: 134, homeSlot: 15, awaySlot: 12 },
  { day: 134, homeSlot: 17, awaySlot: 14 },
  { day: 134, homeSlot: 19, awaySlot: 16 },
  { day: 134, homeSlot: 20, awaySlot: 2 },
  { day: 134, homeSlot: 23, awaySlot: 22 },
  { day: 135, homeSlot: 0, awaySlot: 12 },
  { day: 135, homeSlot: 1, awaySlot: 23 },
  { day: 135, homeSlot: 2, awaySlot: 3 },
  { day: 135, homeSlot: 8, awaySlot: 4 },
  { day: 135, homeSlot: 9, awaySlot: 6 },
  { day: 135, homeSlot: 10, awaySlot: 19 },
  { day: 135, homeSlot: 11, awaySlot: 5 },
  { day: 135, homeSlot: 17, awaySlot: 14 },
  { day: 135, homeSlot: 18, awaySlot: 16 },
  { day: 135, homeSlot: 20, awaySlot: 13 },
  { day: 135, homeSlot: 21, awaySlot: 7 },
  { day: 135, homeSlot: 22, awaySlot: 15 },
  { day: 136, homeSlot: 1, awaySlot: 16 },
  { day: 136, homeSlot: 5, awaySlot: 17 },
  { day: 136, homeSlot: 8, awaySlot: 4 },
  { day: 136, homeSlot: 9, awaySlot: 0 },
  { day: 136, homeSlot: 10, awaySlot: 3 },
  { day: 136, homeSlot: 11, awaySlot: 7 },
  { day: 136, homeSlot: 13, awaySlot: 12 },
  { day: 136, homeSlot: 15, awaySlot: 21 },
  { day: 136, homeSlot: 19, awaySlot: 2 },
  { day: 136, homeSlot: 20, awaySlot: 18 },
  { day: 136, homeSlot: 22, awaySlot: 14 },
  { day: 136, homeSlot: 23, awaySlot: 6 },
  { day: 137, homeSlot: 1, awaySlot: 21 },
  { day: 137, homeSlot: 5, awaySlot: 3 },
  { day: 137, homeSlot: 6, awaySlot: 4 },
  { day: 137, homeSlot: 7, awaySlot: 0 },
  { day: 137, homeSlot: 8, awaySlot: 11 },
  { day: 137, homeSlot: 9, awaySlot: 13 },
  { day: 137, homeSlot: 10, awaySlot: 17 },
  { day: 137, homeSlot: 12, awaySlot: 22 },
  { day: 137, homeSlot: 14, awaySlot: 19 },
  { day: 137, homeSlot: 15, awaySlot: 16 },
  { day: 137, homeSlot: 18, awaySlot: 2 },
  { day: 137, homeSlot: 23, awaySlot: 20 },
  { day: 138, homeSlot: 2, awaySlot: 5 },
  { day: 138, homeSlot: 4, awaySlot: 0 },
  { day: 138, homeSlot: 8, awaySlot: 6 },
  { day: 138, homeSlot: 10, awaySlot: 3 },
  { day: 138, homeSlot: 12, awaySlot: 13 },
  { day: 138, homeSlot: 14, awaySlot: 15 },
  { day: 138, homeSlot: 16, awaySlot: 23 },
  { day: 138, homeSlot: 19, awaySlot: 18 },
  { day: 138, homeSlot: 20, awaySlot: 17 },
  { day: 138, homeSlot: 21, awaySlot: 1 },
  { day: 138, homeSlot: 22, awaySlot: 9 },
  { day: 139, homeSlot: 2, awaySlot: 0 },
  { day: 139, homeSlot: 3, awaySlot: 1 },
  { day: 139, homeSlot: 4, awaySlot: 9 },
  { day: 139, homeSlot: 6, awaySlot: 5 },
  { day: 139, homeSlot: 7, awaySlot: 14 },
  { day: 139, homeSlot: 8, awaySlot: 11 },
  { day: 139, homeSlot: 15, awaySlot: 13 },
  { day: 139, homeSlot: 16, awaySlot: 10 },
  { day: 139, homeSlot: 18, awaySlot: 22 },
  { day: 139, homeSlot: 19, awaySlot: 20 },
  { day: 139, homeSlot: 21, awaySlot: 17 },
  { day: 139, homeSlot: 23, awaySlot: 12 },
  { day: 140, homeSlot: 1, awaySlot: 0 },
  { day: 140, homeSlot: 3, awaySlot: 5 },
  { day: 140, homeSlot: 4, awaySlot: 2 },
  { day: 140, homeSlot: 9, awaySlot: 8 },
  { day: 140, homeSlot: 10, awaySlot: 6 },
  { day: 140, homeSlot: 12, awaySlot: 18 },
  { day: 140, homeSlot: 16, awaySlot: 15 },
  { day: 140, homeSlot: 17, awaySlot: 13 },
  { day: 140, homeSlot: 21, awaySlot: 20 },
  { day: 140, homeSlot: 22, awaySlot: 19 },
  { day: 140, homeSlot: 23, awaySlot: 14 },
  { day: 141, homeSlot: 0, awaySlot: 6 },
  { day: 141, homeSlot: 3, awaySlot: 10 },
  { day: 141, homeSlot: 4, awaySlot: 9 },
  { day: 141, homeSlot: 5, awaySlot: 2 },
  { day: 141, homeSlot: 8, awaySlot: 1 },
  { day: 141, homeSlot: 11, awaySlot: 19 },
  { day: 141, homeSlot: 14, awaySlot: 13 },
  { day: 141, homeSlot: 16, awaySlot: 18 },
  { day: 141, homeSlot: 17, awaySlot: 15 },
  { day: 141, homeSlot: 20, awaySlot: 23 },
  { day: 141, homeSlot: 22, awaySlot: 21 },
  { day: 142, homeSlot: 0, awaySlot: 10 },
  { day: 142, homeSlot: 2, awaySlot: 11 },
  { day: 142, homeSlot: 3, awaySlot: 13 },
  { day: 142, homeSlot: 5, awaySlot: 1 },
  { day: 142, homeSlot: 8, awaySlot: 16 },
  { day: 142, homeSlot: 9, awaySlot: 7 },
  { day: 142, homeSlot: 12, awaySlot: 15 },
  { day: 142, homeSlot: 14, awaySlot: 18 },
  { day: 142, homeSlot: 17, awaySlot: 4 },
  { day: 142, homeSlot: 20, awaySlot: 19 },
  { day: 142, homeSlot: 22, awaySlot: 21 },
  { day: 142, homeSlot: 23, awaySlot: 6 },
  { day: 144, homeSlot: 3, awaySlot: 4 },
  { day: 144, homeSlot: 5, awaySlot: 22 },
  { day: 144, homeSlot: 6, awaySlot: 7 },
  { day: 144, homeSlot: 9, awaySlot: 8 },
  { day: 144, homeSlot: 10, awaySlot: 0 },
  { day: 144, homeSlot: 11, awaySlot: 13 },
  { day: 144, homeSlot: 15, awaySlot: 1 },
  { day: 144, homeSlot: 17, awaySlot: 14 },
  { day: 144, homeSlot: 18, awaySlot: 16 },
  { day: 144, homeSlot: 19, awaySlot: 21 },
  { day: 144, homeSlot: 23, awaySlot: 12 },
  { day: 145, homeSlot: 1, awaySlot: 0 },
  { day: 145, homeSlot: 6, awaySlot: 2 },
  { day: 145, homeSlot: 8, awaySlot: 18 },
  { day: 145, homeSlot: 10, awaySlot: 7 },
  { day: 145, homeSlot: 11, awaySlot: 16 },
  { day: 145, homeSlot: 12, awaySlot: 9 },
  { day: 145, homeSlot: 14, awaySlot: 17 },
  { day: 145, homeSlot: 20, awaySlot: 5 },
  { day: 145, homeSlot: 21, awaySlot: 15 },
  { day: 145, homeSlot: 22, awaySlot: 3 },
  { day: 145, homeSlot: 23, awaySlot: 19 },
  { day: 146, homeSlot: 2, awaySlot: 1 },
  { day: 146, homeSlot: 4, awaySlot: 0 },
  { day: 146, homeSlot: 5, awaySlot: 15 },
  { day: 146, homeSlot: 6, awaySlot: 10 },
  { day: 146, homeSlot: 7, awaySlot: 23 },
  { day: 146, homeSlot: 8, awaySlot: 3 },
  { day: 146, homeSlot: 11, awaySlot: 22 },
  { day: 146, homeSlot: 14, awaySlot: 9 },
  { day: 146, homeSlot: 16, awaySlot: 12 },
  { day: 146, homeSlot: 18, awaySlot: 13 },
  { day: 146, homeSlot: 20, awaySlot: 17 },
  { day: 146, homeSlot: 21, awaySlot: 19 },
  { day: 147, homeSlot: 3, awaySlot: 0 },
  { day: 147, homeSlot: 4, awaySlot: 1 },
  { day: 147, homeSlot: 6, awaySlot: 2 },
  { day: 147, homeSlot: 8, awaySlot: 7 },
  { day: 147, homeSlot: 9, awaySlot: 11 },
  { day: 147, homeSlot: 10, awaySlot: 20 },
  { day: 147, homeSlot: 13, awaySlot: 19 },
  { day: 147, homeSlot: 15, awaySlot: 21 },
  { day: 147, homeSlot: 16, awaySlot: 23 },
  { day: 147, homeSlot: 17, awaySlot: 12 },
  { day: 147, homeSlot: 22, awaySlot: 14 },
  { day: 148, homeSlot: 0, awaySlot: 4 },
  { day: 148, homeSlot: 1, awaySlot: 5 },
  { day: 148, homeSlot: 3, awaySlot: 2 },
  { day: 148, homeSlot: 8, awaySlot: 21 },
  { day: 148, homeSlot: 11, awaySlot: 6 },
  { day: 148, homeSlot: 12, awaySlot: 19 },
  { day: 148, homeSlot: 14, awaySlot: 13 },
  { day: 148, homeSlot: 15, awaySlot: 18 },
  { day: 148, homeSlot: 16, awaySlot: 7 },
  { day: 148, homeSlot: 17, awaySlot: 10 },
  { day: 148, homeSlot: 22, awaySlot: 20 },
  { day: 148, homeSlot: 23, awaySlot: 9 },
  { day: 149, homeSlot: 0, awaySlot: 12 },
  { day: 149, homeSlot: 2, awaySlot: 1 },
  { day: 149, homeSlot: 4, awaySlot: 14 },
  { day: 149, homeSlot: 5, awaySlot: 16 },
  { day: 149, homeSlot: 7, awaySlot: 19 },
  { day: 149, homeSlot: 9, awaySlot: 8 },
  { day: 149, homeSlot: 11, awaySlot: 6 },
  { day: 149, homeSlot: 15, awaySlot: 23 },
  { day: 149, homeSlot: 17, awaySlot: 3 },
  { day: 149, homeSlot: 20, awaySlot: 21 },
  { day: 149, homeSlot: 22, awaySlot: 13 },
  { day: 150, homeSlot: 2, awaySlot: 4 },
  { day: 150, homeSlot: 3, awaySlot: 1 },
  { day: 150, homeSlot: 5, awaySlot: 0 },
  { day: 150, homeSlot: 6, awaySlot: 14 },
  { day: 150, homeSlot: 8, awaySlot: 16 },
  { day: 150, homeSlot: 9, awaySlot: 11 },
  { day: 150, homeSlot: 10, awaySlot: 7 },
  { day: 150, homeSlot: 13, awaySlot: 22 },
  { day: 150, homeSlot: 15, awaySlot: 12 },
  { day: 150, homeSlot: 20, awaySlot: 19 },
  { day: 150, homeSlot: 21, awaySlot: 17 },
  { day: 150, homeSlot: 23, awaySlot: 18 },
  { day: 151, homeSlot: 0, awaySlot: 13 },
  { day: 151, homeSlot: 3, awaySlot: 6 },
  { day: 151, homeSlot: 5, awaySlot: 2 },
  { day: 151, homeSlot: 7, awaySlot: 9 },
  { day: 151, homeSlot: 10, awaySlot: 16 },
  { day: 151, homeSlot: 11, awaySlot: 4 },
  { day: 151, homeSlot: 14, awaySlot: 12 },
  { day: 151, homeSlot: 15, awaySlot: 8 },
  { day: 151, homeSlot: 17, awaySlot: 21 },
  { day: 151, homeSlot: 18, awaySlot: 20 },
  { day: 151, homeSlot: 19, awaySlot: 1 },
  { day: 151, homeSlot: 23, awaySlot: 22 },
  { day: 152, homeSlot: 4, awaySlot: 11 },
  { day: 152, homeSlot: 5, awaySlot: 0 },
  { day: 152, homeSlot: 6, awaySlot: 3 },
  { day: 152, homeSlot: 10, awaySlot: 1 },
  { day: 152, homeSlot: 12, awaySlot: 21 },
  { day: 152, homeSlot: 15, awaySlot: 13 },
  { day: 152, homeSlot: 16, awaySlot: 18 },
  { day: 152, homeSlot: 17, awaySlot: 9 },
  { day: 152, homeSlot: 19, awaySlot: 14 },
  { day: 152, homeSlot: 20, awaySlot: 7 },
  { day: 152, homeSlot: 22, awaySlot: 8 },
  { day: 152, homeSlot: 23, awaySlot: 2 },
  { day: 153, homeSlot: 1, awaySlot: 12 },
  { day: 153, homeSlot: 2, awaySlot: 11 },
  { day: 153, homeSlot: 4, awaySlot: 22 },
  { day: 153, homeSlot: 5, awaySlot: 3 },
  { day: 153, homeSlot: 9, awaySlot: 7 },
  { day: 153, homeSlot: 10, awaySlot: 0 },
  { day: 153, homeSlot: 14, awaySlot: 16 },
  { day: 153, homeSlot: 17, awaySlot: 19 },
  { day: 153, homeSlot: 20, awaySlot: 18 },
  { day: 153, homeSlot: 21, awaySlot: 6 },
  { day: 153, homeSlot: 23, awaySlot: 13 },
  { day: 154, homeSlot: 2, awaySlot: 11 },
  { day: 154, homeSlot: 3, awaySlot: 7 },
  { day: 154, homeSlot: 5, awaySlot: 10 },
  { day: 154, homeSlot: 8, awaySlot: 6 },
  { day: 154, homeSlot: 9, awaySlot: 1 },
  { day: 154, homeSlot: 12, awaySlot: 21 },
  { day: 154, homeSlot: 13, awaySlot: 17 },
  { day: 154, homeSlot: 14, awaySlot: 22 },
  { day: 154, homeSlot: 15, awaySlot: 4 },
  { day: 154, homeSlot: 16, awaySlot: 19 },
  { day: 154, homeSlot: 20, awaySlot: 18 },
  { day: 154, homeSlot: 23, awaySlot: 0 },
  { day: 156, homeSlot: 2, awaySlot: 10 },
  { day: 156, homeSlot: 5, awaySlot: 13 },
  { day: 156, homeSlot: 7, awaySlot: 0 },
  { day: 156, homeSlot: 9, awaySlot: 6 },
  { day: 156, homeSlot: 11, awaySlot: 4 },
  { day: 156, homeSlot: 12, awaySlot: 3 },
  { day: 156, homeSlot: 14, awaySlot: 16 },
  { day: 156, homeSlot: 15, awaySlot: 21 },
  { day: 156, homeSlot: 17, awaySlot: 1 },
  { day: 156, homeSlot: 20, awaySlot: 19 },
  { day: 156, homeSlot: 22, awaySlot: 18 },
  { day: 157, homeSlot: 2, awaySlot: 10 },
  { day: 157, homeSlot: 8, awaySlot: 7 },
  { day: 157, homeSlot: 11, awaySlot: 9 },
  { day: 157, homeSlot: 13, awaySlot: 17 },
  { day: 157, homeSlot: 15, awaySlot: 14 },
  { day: 157, homeSlot: 16, awaySlot: 5 },
  { day: 157, homeSlot: 18, awaySlot: 6 },
  { day: 157, homeSlot: 19, awaySlot: 3 },
  { day: 157, homeSlot: 20, awaySlot: 0 },
  { day: 157, homeSlot: 21, awaySlot: 12 },
  { day: 157, homeSlot: 22, awaySlot: 4 },
  { day: 157, homeSlot: 23, awaySlot: 1 },
  { day: 158, homeSlot: 1, awaySlot: 6 },
  { day: 158, homeSlot: 4, awaySlot: 2 },
  { day: 158, homeSlot: 5, awaySlot: 10 },
  { day: 158, homeSlot: 7, awaySlot: 0 },
  { day: 158, homeSlot: 9, awaySlot: 17 },
  { day: 158, homeSlot: 11, awaySlot: 8 },
  { day: 158, homeSlot: 14, awaySlot: 12 },
  { day: 158, homeSlot: 15, awaySlot: 23 },
  { day: 158, homeSlot: 16, awaySlot: 20 },
  { day: 158, homeSlot: 18, awaySlot: 3 },
  { day: 158, homeSlot: 21, awaySlot: 19 },
  { day: 158, homeSlot: 22, awaySlot: 13 },
  { day: 159, homeSlot: 2, awaySlot: 13 },
  { day: 159, homeSlot: 5, awaySlot: 1 },
  { day: 159, homeSlot: 6, awaySlot: 23 },
  { day: 159, homeSlot: 7, awaySlot: 9 },
  { day: 159, homeSlot: 8, awaySlot: 4 },
  { day: 159, homeSlot: 10, awaySlot: 3 },
  { day: 159, homeSlot: 11, awaySlot: 0 },
  { day: 159, homeSlot: 14, awaySlot: 12 },
  { day: 159, homeSlot: 17, awaySlot: 15 },
  { day: 159, homeSlot: 20, awaySlot: 19 },
  { day: 159, homeSlot: 21, awaySlot: 18 },
  { day: 159, homeSlot: 22, awaySlot: 16 },
  { day: 160, homeSlot: 1, awaySlot: 7 },
  { day: 160, homeSlot: 3, awaySlot: 4 },
  { day: 160, homeSlot: 8, awaySlot: 0 },
  { day: 160, homeSlot: 9, awaySlot: 6 },
  { day: 160, homeSlot: 15, awaySlot: 12 },
  { day: 160, homeSlot: 16, awaySlot: 19 },
  { day: 160, homeSlot: 17, awaySlot: 14 },
  { day: 160, homeSlot: 18, awaySlot: 22 },
  { day: 160, homeSlot: 20, awaySlot: 13 },
  { day: 160, homeSlot: 21, awaySlot: 5 },
  { day: 160, homeSlot: 23, awaySlot: 11 },
  { day: 161, homeSlot: 1, awaySlot: 11 },
  { day: 161, homeSlot: 3, awaySlot: 15 },
  { day: 161, homeSlot: 6, awaySlot: 21 },
  { day: 161, homeSlot: 8, awaySlot: 5 },
  { day: 161, homeSlot: 9, awaySlot: 18 },
  { day: 161, homeSlot: 10, awaySlot: 7 },
  { day: 161, homeSlot: 13, awaySlot: 0 },
  { day: 161, homeSlot: 17, awaySlot: 12 },
  { day: 161, homeSlot: 19, awaySlot: 4 },
  { day: 161, homeSlot: 22, awaySlot: 20 },
  { day: 161, homeSlot: 23, awaySlot: 14 },
  { day: 162, homeSlot: 1, awaySlot: 9 },
  { day: 162, homeSlot: 4, awaySlot: 11 },
  { day: 162, homeSlot: 5, awaySlot: 6 },
  { day: 162, homeSlot: 7, awaySlot: 2 },
  { day: 162, homeSlot: 8, awaySlot: 3 },
  { day: 162, homeSlot: 12, awaySlot: 21 },
  { day: 162, homeSlot: 14, awaySlot: 23 },
  { day: 162, homeSlot: 15, awaySlot: 16 },
  { day: 162, homeSlot: 18, awaySlot: 0 },
  { day: 162, homeSlot: 19, awaySlot: 10 },
  { day: 162, homeSlot: 20, awaySlot: 17 },
  { day: 163, homeSlot: 1, awaySlot: 11 },
  { day: 163, homeSlot: 3, awaySlot: 2 },
  { day: 163, homeSlot: 5, awaySlot: 6 },
  { day: 163, homeSlot: 8, awaySlot: 7 },
  { day: 163, homeSlot: 9, awaySlot: 10 },
  { day: 163, homeSlot: 12, awaySlot: 14 },
  { day: 163, homeSlot: 16, awaySlot: 15 },
  { day: 163, homeSlot: 17, awaySlot: 0 },
  { day: 163, homeSlot: 18, awaySlot: 4 },
  { day: 163, homeSlot: 21, awaySlot: 19 },
  { day: 163, homeSlot: 22, awaySlot: 20 },
  { day: 163, homeSlot: 23, awaySlot: 13 },
  { day: 164, homeSlot: 1, awaySlot: 15 },
  { day: 164, homeSlot: 3, awaySlot: 0 },
  { day: 164, homeSlot: 4, awaySlot: 8 },
  { day: 164, homeSlot: 5, awaySlot: 11 },
  { day: 164, homeSlot: 6, awaySlot: 7 },
  { day: 164, homeSlot: 9, awaySlot: 22 },
  { day: 164, homeSlot: 14, awaySlot: 19 },
  { day: 164, homeSlot: 16, awaySlot: 13 },
  { day: 164, homeSlot: 18, awaySlot: 12 },
  { day: 164, homeSlot: 20, awaySlot: 10 },
  { day: 164, homeSlot: 23, awaySlot: 21 },
  { day: 165, homeSlot: 1, awaySlot: 3 },
  { day: 165, homeSlot: 2, awaySlot: 6 },
  { day: 165, homeSlot: 4, awaySlot: 23 },
  { day: 165, homeSlot: 5, awaySlot: 0 },
  { day: 165, homeSlot: 7, awaySlot: 13 },
  { day: 165, homeSlot: 9, awaySlot: 14 },
  { day: 165, homeSlot: 10, awaySlot: 8 },
  { day: 165, homeSlot: 18, awaySlot: 12 },
  { day: 165, homeSlot: 19, awaySlot: 11 },
  { day: 165, homeSlot: 20, awaySlot: 17 },
  { day: 165, homeSlot: 21, awaySlot: 22 },
  { day: 167, homeSlot: 1, awaySlot: 0 },
  { day: 167, homeSlot: 5, awaySlot: 2 },
  { day: 167, homeSlot: 6, awaySlot: 18 },
  { day: 167, homeSlot: 9, awaySlot: 11 },
  { day: 167, homeSlot: 10, awaySlot: 8 },
  { day: 167, homeSlot: 14, awaySlot: 12 },
  { day: 167, homeSlot: 15, awaySlot: 7 },
  { day: 167, homeSlot: 16, awaySlot: 13 },
  { day: 167, homeSlot: 21, awaySlot: 4 },
  { day: 167, homeSlot: 22, awaySlot: 19 },
  { day: 167, homeSlot: 23, awaySlot: 20 },
  { day: 168, homeSlot: 2, awaySlot: 5 },
  { day: 168, homeSlot: 3, awaySlot: 8 },
  { day: 168, homeSlot: 4, awaySlot: 0 },
  { day: 168, homeSlot: 9, awaySlot: 7 },
  { day: 168, homeSlot: 11, awaySlot: 10 },
  { day: 168, homeSlot: 12, awaySlot: 6 },
  { day: 168, homeSlot: 16, awaySlot: 14 },
  { day: 168, homeSlot: 17, awaySlot: 1 },
  { day: 168, homeSlot: 20, awaySlot: 19 },
  { day: 168, homeSlot: 21, awaySlot: 18 },
  { day: 168, homeSlot: 23, awaySlot: 22 },
  { day: 169, homeSlot: 2, awaySlot: 4 },
  { day: 169, homeSlot: 3, awaySlot: 9 },
  { day: 169, homeSlot: 5, awaySlot: 1 },
  { day: 169, homeSlot: 7, awaySlot: 18 },
  { day: 169, homeSlot: 8, awaySlot: 11 },
  { day: 169, homeSlot: 10, awaySlot: 16 },
  { day: 169, homeSlot: 12, awaySlot: 15 },
  { day: 169, homeSlot: 13, awaySlot: 20 },
  { day: 169, homeSlot: 21, awaySlot: 14 },
  { day: 169, homeSlot: 22, awaySlot: 17 },
  { day: 169, homeSlot: 23, awaySlot: 19 },
  { day: 170, homeSlot: 4, awaySlot: 2 },
  { day: 170, homeSlot: 5, awaySlot: 3 },
  { day: 170, homeSlot: 7, awaySlot: 6 },
  { day: 170, homeSlot: 10, awaySlot: 9 },
  { day: 170, homeSlot: 11, awaySlot: 0 },
  { day: 170, homeSlot: 15, awaySlot: 12 },
  { day: 170, homeSlot: 16, awaySlot: 14 },
  { day: 170, homeSlot: 17, awaySlot: 13 },
  { day: 170, homeSlot: 19, awaySlot: 18 },
  { day: 170, homeSlot: 21, awaySlot: 20 },
  { day: 170, homeSlot: 22, awaySlot: 1 },
  { day: 171, homeSlot: 0, awaySlot: 9 },
  { day: 171, homeSlot: 2, awaySlot: 7 },
  { day: 171, homeSlot: 3, awaySlot: 11 },
  { day: 171, homeSlot: 5, awaySlot: 16 },
  { day: 171, homeSlot: 6, awaySlot: 13 },
  { day: 171, homeSlot: 8, awaySlot: 10 },
  { day: 171, homeSlot: 12, awaySlot: 15 },
  { day: 171, homeSlot: 19, awaySlot: 18 },
  { day: 171, homeSlot: 21, awaySlot: 20 },
  { day: 171, homeSlot: 22, awaySlot: 17 },
  { day: 172, homeSlot: 1, awaySlot: 0 },
  { day: 172, homeSlot: 3, awaySlot: 13 },
  { day: 172, homeSlot: 5, awaySlot: 4 },
  { day: 172, homeSlot: 8, awaySlot: 6 },
  { day: 172, homeSlot: 9, awaySlot: 7 },
  { day: 172, homeSlot: 11, awaySlot: 2 },
  { day: 172, homeSlot: 14, awaySlot: 12 },
  { day: 172, homeSlot: 15, awaySlot: 20 },
  { day: 172, homeSlot: 16, awaySlot: 21 },
  { day: 172, homeSlot: 19, awaySlot: 22 },
  { day: 172, homeSlot: 23, awaySlot: 18 },
  { day: 173, homeSlot: 2, awaySlot: 5 },
  { day: 173, homeSlot: 4, awaySlot: 3 },
  { day: 173, homeSlot: 7, awaySlot: 16 },
  { day: 173, homeSlot: 8, awaySlot: 6 },
  { day: 173, homeSlot: 13, awaySlot: 11 },
  { day: 173, homeSlot: 14, awaySlot: 19 },
  { day: 173, homeSlot: 17, awaySlot: 20 },
  { day: 173, homeSlot: 18, awaySlot: 15 },
  { day: 173, homeSlot: 23, awaySlot: 21 },
  { day: 174, homeSlot: 0, awaySlot: 23 },
  { day: 174, homeSlot: 3, awaySlot: 2 },
  { day: 174, homeSlot: 4, awaySlot: 18 },
  { day: 174, homeSlot: 7, awaySlot: 21 },
  { day: 174, homeSlot: 8, awaySlot: 9 },
  { day: 174, homeSlot: 10, awaySlot: 11 },
  { day: 174, homeSlot: 16, awaySlot: 13 },
  { day: 174, homeSlot: 17, awaySlot: 14 },
  { day: 174, homeSlot: 20, awaySlot: 15 },
  { day: 174, homeSlot: 22, awaySlot: 5 },
  { day: 175, homeSlot: 2, awaySlot: 7 },
  { day: 175, homeSlot: 4, awaySlot: 19 },
  { day: 175, homeSlot: 9, awaySlot: 3 },
  { day: 175, homeSlot: 10, awaySlot: 6 },
  { day: 175, homeSlot: 11, awaySlot: 8 },
  { day: 175, homeSlot: 12, awaySlot: 20 },
  { day: 175, homeSlot: 15, awaySlot: 5 },
  { day: 175, homeSlot: 17, awaySlot: 16 },
  { day: 175, homeSlot: 18, awaySlot: 1 },
  { day: 175, homeSlot: 23, awaySlot: 21 },
  { day: 176, homeSlot: 0, awaySlot: 3 },
  { day: 176, homeSlot: 1, awaySlot: 7 },
  { day: 176, homeSlot: 2, awaySlot: 12 },
  { day: 176, homeSlot: 6, awaySlot: 15 },
  { day: 176, homeSlot: 11, awaySlot: 10 },
  { day: 176, homeSlot: 13, awaySlot: 8 },
  { day: 176, homeSlot: 16, awaySlot: 22 },
  { day: 176, homeSlot: 18, awaySlot: 21 },
  { day: 176, homeSlot: 20, awaySlot: 9 },
  { day: 178, homeSlot: 2, awaySlot: 1 },
  { day: 178, homeSlot: 7, awaySlot: 5 },
  { day: 178, homeSlot: 9, awaySlot: 4 },
  { day: 178, homeSlot: 11, awaySlot: 8 },
  { day: 178, homeSlot: 12, awaySlot: 15 },
  { day: 178, homeSlot: 16, awaySlot: 13 },
  { day: 178, homeSlot: 22, awaySlot: 21 },
  { day: 178, homeSlot: 23, awaySlot: 20 },
  { day: 179, homeSlot: 3, awaySlot: 2 },
  { day: 179, homeSlot: 5, awaySlot: 0 },
  { day: 179, homeSlot: 7, awaySlot: 1 },
  { day: 179, homeSlot: 8, awaySlot: 10 },
  { day: 179, homeSlot: 9, awaySlot: 4 },
  { day: 179, homeSlot: 11, awaySlot: 15 },
  { day: 179, homeSlot: 16, awaySlot: 14 },
  { day: 179, homeSlot: 17, awaySlot: 13 },
  { day: 179, homeSlot: 23, awaySlot: 21 },
  { day: 180, homeSlot: 8, awaySlot: 0 },
  { day: 180, homeSlot: 9, awaySlot: 6 },
  { day: 180, homeSlot: 10, awaySlot: 21 },
  { day: 180, homeSlot: 11, awaySlot: 19 },
  { day: 180, homeSlot: 17, awaySlot: 12 },
  { day: 180, homeSlot: 18, awaySlot: 2 },
  { day: 180, homeSlot: 23, awaySlot: 22 },
  { day: 181, homeSlot: 2, awaySlot: 19 },
  { day: 181, homeSlot: 4, awaySlot: 9 },
  { day: 181, homeSlot: 7, awaySlot: 6 },
  { day: 181, homeSlot: 10, awaySlot: 13 },
  { day: 181, homeSlot: 14, awaySlot: 12 },
  { day: 181, homeSlot: 17, awaySlot: 22 },
  { day: 181, homeSlot: 23, awaySlot: 21 },
  { day: 182, homeSlot: 2, awaySlot: 0 },
  { day: 182, homeSlot: 11, awaySlot: 10 },
  { day: 182, homeSlot: 15, awaySlot: 21 },
  { day: 182, homeSlot: 23, awaySlot: 18 },
  { day: 183, homeSlot: 1, awaySlot: 2 },
  { day: 183, homeSlot: 10, awaySlot: 5 },
  { day: 183, homeSlot: 11, awaySlot: 14 },
  { day: 183, homeSlot: 18, awaySlot: 13 },
  { day: 183, homeSlot: 21, awaySlot: 17 },
];

// Total: 1920 games
